var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--aiZGp2--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.39,67.83a68.06,68.06,0,0,0-4.61,21.06H50.12v-.52c.05-.48.11-1,.15-1.43a50.58,50.58,0,0,1,1.24-7.35,57.2,57.2,0,0,1,4.14-11.5.42.42,0,0,1,.45-.27H73.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.82,114.88H55.68a.38.38,0,0,1-.41-.27,52.26,52.26,0,0,1-4.26-13,53.23,53.23,0,0,1-.84-6.56,2.25,2.25,0,0,0-.05-.22v-.52l.28,0H68.45c.34,0,.32,0,.35.34.11,1.5.21,3,.35,4.49a60,60,0,0,0,1.15,7.06,62.88,62.88,0,0,0,2.44,8.39C72.77,114.69,72.79,114.77,72.82,114.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.91,120.31c-.06.1-.1.18-.15.25a51.05,51.05,0,0,1-4.86,6.3,48,48,0,0,1-7.11,6.56,50.84,50.84,0,0,1-16.68,8.36A53,53,0,0,1,109,143.3c-.24,0-.47.08-.7.12h-.42l-.39-.25.45-.33a54.68,54.68,0,0,0,13.52-13.11,62.56,62.56,0,0,0,5.52-9.16.39.39,0,0,1,.42-.27h17.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.76,88.88H103.68v-21h18.8a.35.35,0,0,1,.38.25,58.54,58.54,0,0,1,3.83,12.33,62.56,62.56,0,0,1,.93,6.67C127.66,87.67,127.71,88.26,127.76,88.88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.62,94.49c0,.5,0,1-.07,1.48-.11,1.18-.19,2.35-.36,3.52-.22,1.61-.47,3.22-.79,4.82a57.65,57.65,0,0,1-3.12,10.27.41.41,0,0,1-.44.31h-19.3V94.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.26,68V89H74.75c0-.53,0-1.06.1-1.58.12-1.17.22-2.36.4-3.53.29-1.78.6-3.57,1-5.34a54.15,54.15,0,0,1,3.4-10.36A.36.36,0,0,1,80,68H98.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.28,94.77q0,9.9,0,19.81v.3H79.49a.38.38,0,0,1-.41-.27A53.46,53.46,0,0,1,75.88,104c-.35-1.87-.62-3.76-.86-5.65-.16-1.23-.19-2.48-.28-3.73,0,0,0-.06,0-.13H98C98.23,94.46,98.28,94.54,98.28,94.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29,89H133.56A68.45,68.45,0,0,0,129,67.83h18.39a.4.4,0,0,1,.43.26,51.79,51.79,0,0,1,4.55,13.19,55.68,55.68,0,0,1,1,7.4C153.3,88.78,153.29,88.89,153.29,89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.31,94.33c0,.48,0,.93-.07,1.38a52.36,52.36,0,0,1-.65,5.31A51.71,51.71,0,0,1,149,112.87c-.27.61-.56,1.22-.84,1.82a.27.27,0,0,1-.29.19H129.71l-.19,0,.64-1.85a64.51,64.51,0,0,0,3.29-16.77c0-.56.07-1.13.1-1.7,0-.15,0-.22.2-.21a1.2,1.2,0,0,0,.19,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.37,62.46a.59.59,0,0,0,0,.08H126.82a.39.39,0,0,1-.41-.24,59.32,59.32,0,0,0-8.57-12.69,47.12,47.12,0,0,0-6.57-6.06c-1.18-.91-2.4-1.76-3.6-2.63l-.2-.15.24-.16c0-.11-.07-.22-.11-.38a51.63,51.63,0,0,1,36.77,22.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.91,143.18a1.76,1.76,0,0,1-.5.08,46.85,46.85,0,0,1-5.62-1.09,50.62,50.62,0,0,1-20.22-10.41,48.79,48.79,0,0,1-6.14-6.14,51.34,51.34,0,0,1-3.83-5.3l-.08-.16H74.87a.4.4,0,0,1,.41.26,62.11,62.11,0,0,0,5.9,9.63,61.3,61.3,0,0,0,6.92,7.66,53.79,53.79,0,0,0,6.67,5.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,40.75c-.73.53-1.6,1.14-2.43,1.78a60.07,60.07,0,0,0-7.79,7.25,54.54,54.54,0,0,0-8.17,11.65c-.14.27-.26.55-.41.8a.38.38,0,0,1-.25.16c-.29,0-.59,0-.88,0H59.06C67.81,50,79.57,42.61,94.52,40.34l-.1.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,120.32a56.61,56.61,0,0,1-8,10.76,50.14,50.14,0,0,1-9.09,7.71V120.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,120.33v18.11a52.46,52.46,0,0,1-16.34-18.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,62.38H103.69V45.13a50,50,0,0,1,9.17,7.68A57.64,57.64,0,0,1,120,62.38Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.26,45.67V62.52H82.56A49.67,49.67,0,0,1,98.26,45.67Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 445.43,
    y: 52.34,
    width: 234.33,
    height: 176.95,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.43,
    y: 52.34,
    width: 234.33,
    height: 11.76,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.46,58.3a3,3,0,1,1-3-3A3,3,0,0,1,456.46,58.3Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.54,58.3a3,3,0,1,1-3-3A3,3,0,0,1,468.54,58.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.61,58.3a3,3,0,1,1-3-3A3,3,0,0,1,480.61,58.3Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.26,
    y: 155.58,
    width: 129.28,
    height: 93.13,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.26,
    y: 155.58,
    width: 129.28,
    height: 11.76,
    style: {
      fill: "none",
      stroke: "#ebebeb",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.29,161.54a3,3,0,1,1-3-2.95A3,3,0,0,1,70.29,161.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.37,161.54a3,3,0,1,1-3-2.95A3,3,0,0,1,82.37,161.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.44,161.54a3,3,0,1,1-3-2.95A3,3,0,0,1,94.44,161.54Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 424.48 131.79 424.24 212.86 424.15 375 423.98 537.14 424.15 618.21 424.23 699.28 424.48 618.21 424.72 537.14 424.81 375 424.98 212.86 424.81 131.79 424.72 50.72 424.48",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.99,
    y: 77.91,
    width: 572.17,
    height: 346.05,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.16,424,89,424.34h-.37V424l-.13-346v-.5H89l572.17.21h.29v.29Zm0,0-.29-346,.29.29L89,78.41l.5-.5-.13,346-.37-.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 133.94,
    width: 15.25,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 144.93,
    width: 15.25,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 139.49,
    width: 15.25,
    height: 2.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.92,
    y: 223.8,
    width: 125.72,
    height: 3.71,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,248.23c10.25-.2,20.49-.29,30.74-.37l30.74-.11,30.75.11,15.37.14,15.37.23-15.37.24-15.37.13-30.75.11-30.74-.11C163.48,248.52,153.24,248.43,143,248.23Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,258c10.25-.2,20.49-.29,30.74-.37l30.74-.11,30.75.11,15.37.13L266,258l-15.37.23-15.37.13-30.75.11-30.74-.11C163.48,258.28,153.24,258.18,143,258Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,267.74c10.25-.2,20.49-.29,30.74-.36l30.74-.12,30.75.11,15.37.14,15.37.23-15.37.24-15.37.13-30.75.11-30.74-.11C163.48,268,153.24,267.94,143,267.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,287.25c10.25-.19,20.49-.29,30.74-.36l30.74-.11,30.75.11,15.37.13,15.37.23-15.37.24-15.37.13-30.75.11-30.74-.11C163.48,287.54,153.24,287.45,143,287.25Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,297c10.25-.2,20.49-.29,30.74-.37l30.74-.11,30.75.11,15.37.13L266,297l-15.37.23-15.37.14-30.75.11-30.74-.11C163.48,297.3,153.24,297.21,143,297Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,306.77c6.24-.2,12.47-.29,18.71-.37s12.47-.07,18.71-.11,12.47,0,18.71.11l9.35.13c3.12.08,6.24.13,9.35.24-3.11.1-6.23.15-9.35.23l-9.35.13c-6.24.08-12.48.08-18.71.11s-12.48,0-18.71-.11S149.23,307,143,306.77Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,203.68h3.58l7.94,20.87h-4.17l-1.94-5.2h-7.3l-1.91,5.2h-4.17Zm4.67,12.82-2.88-8.21-3,8.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.74,219.17a4.76,4.76,0,0,1-2,4,7,7,0,0,1-2.15,1,9.5,9.5,0,0,1-2.6.35H164.92V203.68H176.1a4.07,4.07,0,0,1,2,.47,4.9,4.9,0,0,1,1.49,1.22,5.58,5.58,0,0,1,1,1.7,5.68,5.68,0,0,1-.43,4.79,4.61,4.61,0,0,1-2.23,2,5.35,5.35,0,0,1,2.84,1.9A5.5,5.5,0,0,1,181.74,219.17Zm-12.76-12v5.26h5.41a2.41,2.41,0,0,0,1.75-.71,2.58,2.58,0,0,0,.72-1.94,2.69,2.69,0,0,0-.66-1.91,2.15,2.15,0,0,0-1.63-.7Zm8.67,11.26a3,3,0,0,0-.19-1.08,2.88,2.88,0,0,0-.51-.89,2.39,2.39,0,0,0-.77-.61,2.2,2.2,0,0,0-1-.22H169v5.5h6a2.75,2.75,0,0,0,1-.2,2.58,2.58,0,0,0,.84-.58,2.77,2.77,0,0,0,.56-.87A2.84,2.84,0,0,0,177.65,218.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,224.7a9.47,9.47,0,0,1-4.16-.9,10.26,10.26,0,0,1-3.2-2.38,11.12,11.12,0,0,1-2.81-7.31,10.43,10.43,0,0,1,.78-4,10.87,10.87,0,0,1,2.15-3.39,10.17,10.17,0,0,1,3.25-2.33,9.57,9.57,0,0,1,4.08-.87,9.11,9.11,0,0,1,4.13.93,10.1,10.1,0,0,1,3.19,2.42,11.26,11.26,0,0,1,2.06,3.41,10.77,10.77,0,0,1,.74,3.88,10.81,10.81,0,0,1-2.89,7.34,10.22,10.22,0,0,1-3.23,2.32A9.62,9.62,0,0,1,193.82,224.7Zm-6-10.59a8.21,8.21,0,0,0,.41,2.62,7,7,0,0,0,1.19,2.24,6,6,0,0,0,1.91,1.55,5.38,5.38,0,0,0,2.57.59,5.52,5.52,0,0,0,2.61-.6,6,6,0,0,0,1.91-1.6,7.1,7.1,0,0,0,1.17-2.25,8.23,8.23,0,0,0,.4-2.55,7.94,7.94,0,0,0-.43-2.61,7.09,7.09,0,0,0-1.2-2.24,5.85,5.85,0,0,0-1.91-1.54,5.62,5.62,0,0,0-2.55-.57,5.52,5.52,0,0,0-2.61.6,5.69,5.69,0,0,0-1.91,1.59,7.19,7.19,0,0,0-1.17,2.23A8.47,8.47,0,0,0,187.77,214.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,221.11a4.61,4.61,0,0,0,2.43-.59A4.85,4.85,0,0,0,220,219a6.3,6.3,0,0,0,.85-2.16,13,13,0,0,0,.25-2.51V203.68h4v10.64a15.39,15.39,0,0,1-.52,4,9.13,9.13,0,0,1-1.62,3.29,7.77,7.77,0,0,1-2.83,2.24,9.75,9.75,0,0,1-4.15.82,9.5,9.5,0,0,1-4.25-.87,7.93,7.93,0,0,1-2.83-2.29,9.24,9.24,0,0,1-1.58-3.31,15.74,15.74,0,0,1-.48-3.91V203.68h4.06v10.64a12.36,12.36,0,0,0,.25,2.54A6.11,6.11,0,0,0,212,219a4.57,4.57,0,0,0,1.57,1.52A4.63,4.63,0,0,0,216,221.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.8,207.23h-6.67v17.32h-4V207.23h-6.67v-3.55H244.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44,221.11a4.61,4.61,0,0,0,2.43-.59,4.66,4.66,0,0,0,1.59-1.53,6.3,6.3,0,0,0,.85-2.16,12.21,12.21,0,0,0,.25-2.51V203.68h4v10.64a15,15,0,0,1-.52,4,9.28,9.28,0,0,1-1.61,3.29,7.8,7.8,0,0,1-2.84,2.24,9.75,9.75,0,0,1-4.15.82,9.43,9.43,0,0,1-4.24-.87,7.88,7.88,0,0,1-2.84-2.29,9.24,9.24,0,0,1-1.58-3.31,15.74,15.74,0,0,1-.48-3.91V203.68h4.06v10.64a12.36,12.36,0,0,0,.25,2.54,6.11,6.11,0,0,0,.85,2.16,4.39,4.39,0,0,0,3.95,2.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.11,209.15a4.75,4.75,0,0,0-.75-.56,8,8,0,0,0-1.32-.69,11.56,11.56,0,0,0-1.69-.58,7.75,7.75,0,0,0-1.85-.23,4.15,4.15,0,0,0-2.5.61,2.06,2.06,0,0,0-.83,1.74,1.81,1.81,0,0,0,.31,1.07,2.61,2.61,0,0,0,.9.75,7.33,7.33,0,0,0,1.48.59c.6.18,1.29.36,2.08.56,1,.27,1.94.57,2.77.88a7.4,7.4,0,0,1,2.12,1.18,4.88,4.88,0,0,1,1.34,1.69,5.61,5.61,0,0,1,.47,2.42,6.05,6.05,0,0,1-.63,2.87,5.31,5.31,0,0,1-1.71,1.93,7.46,7.46,0,0,1-2.47,1.07,12.62,12.62,0,0,1-2.92.34,15.76,15.76,0,0,1-4.65-.71,14.28,14.28,0,0,1-4.11-2l1.79-3.5a5.33,5.33,0,0,0,.95.69,14.44,14.44,0,0,0,1.64.86,13.31,13.31,0,0,0,2.08.72,9.78,9.78,0,0,0,2.36.29c2.23,0,3.35-.71,3.35-2.15a1.76,1.76,0,0,0-.38-1.14,3.3,3.3,0,0,0-1.09-.83,10.3,10.3,0,0,0-1.71-.64l-2.23-.65a17.36,17.36,0,0,1-2.6-.9,6.71,6.71,0,0,1-1.84-1.14,4.21,4.21,0,0,1-1.1-1.53,5.21,5.21,0,0,1-.37-2.07,6.43,6.43,0,0,1,.59-2.83,5.56,5.56,0,0,1,1.63-2,7.22,7.22,0,0,1,2.42-1.25,9.83,9.83,0,0,1,3-.43,11.53,11.53,0,0,1,4.06.69,15.47,15.47,0,0,1,3.23,1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 326.86,
    width: 56.57,
    height: 15.56,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,337v-4.77h.47v4.35h2.75V337Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.38,336.6V337h-3.21v-4.77h3.15v.42h-2.68v1.72H157v.39h-2.33v1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.74,332.25h.4l2,4.77h-.5l-.62-1.49h-2.14l-.61,1.49h-.5Zm1.15,2.91-1-2.36-1,2.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,337v-4.77h2a1.33,1.33,0,0,1,.57.13,1.7,1.7,0,0,1,.45.35,1.66,1.66,0,0,1,.29.48,1.47,1.47,0,0,1,.1.54,1.68,1.68,0,0,1-.07.5,1.59,1.59,0,0,1-.22.43,1.12,1.12,0,0,1-.33.32,1.08,1.08,0,0,1-.44.18l1.17,1.84h-.53l-1.12-1.76h-1.41V337Zm.47-2.17h1.56a.83.83,0,0,0,.38-.1,1,1,0,0,0,.29-.24,1.31,1.31,0,0,0,.19-.35,1.4,1.4,0,0,0,.06-.41,1.14,1.14,0,0,0-.07-.41,1.13,1.13,0,0,0-.21-.35,1,1,0,0,0-.31-.23.81.81,0,0,0-.37-.09h-1.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.65,333.13V337h-.47v-4.77h.37l3.15,4v-4h.47V337h-.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.3,337v-3.91l-1.74,3h-.27l-1.74-3V337h-.47v-4.77h.48l1.86,3.27,1.88-3.27h.47V337Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89,337.05a2,2,0,0,1-.91-.2,2.39,2.39,0,0,1-.71-.54,2.55,2.55,0,0,1-.46-.78,2.5,2.5,0,0,1-.16-.89,2.59,2.59,0,0,1,.17-.92,2.56,2.56,0,0,1,.48-.77,2.2,2.2,0,0,1,.71-.53,2,2,0,0,1,.88-.2,2,2,0,0,1,.91.21,2.29,2.29,0,0,1,.71.56,2.56,2.56,0,0,1,.45.77,2.44,2.44,0,0,1,.16.88,2.39,2.39,0,0,1-.17.92,2.53,2.53,0,0,1-.47.77,2.36,2.36,0,0,1-.71.53A2,2,0,0,1,181.89,337.05Zm-1.77-2.41a2.11,2.11,0,0,0,.13.75,1.79,1.79,0,0,0,.36.63,1.74,1.74,0,0,0,.56.45,1.53,1.53,0,0,0,.72.16,1.6,1.6,0,0,0,.73-.17,1.92,1.92,0,0,0,.56-.46,2.09,2.09,0,0,0,.35-.64,2.27,2.27,0,0,0,.12-.72,2.11,2.11,0,0,0-.13-.75,2.35,2.35,0,0,0-.36-.64,2,2,0,0,0-.56-.44,1.54,1.54,0,0,0-.71-.16,1.64,1.64,0,0,0-.74.17,1.84,1.84,0,0,0-.55.45,2.22,2.22,0,0,0-.35.64A2,2,0,0,0,180.12,334.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,337v-4.77h2a1.33,1.33,0,0,1,.57.13,1.7,1.7,0,0,1,.45.35,1.66,1.66,0,0,1,.29.48,1.47,1.47,0,0,1,.1.54,1.42,1.42,0,0,1-.08.5,1.56,1.56,0,0,1-.21.43,1.12,1.12,0,0,1-.33.32,1.14,1.14,0,0,1-.44.18l1.17,1.84H188l-1.12-1.76h-1.41V337Zm.47-2.17H187a.86.86,0,0,0,.38-.1,1,1,0,0,0,.29-.24,1.31,1.31,0,0,0,.19-.35,1.4,1.4,0,0,0,.06-.41,1.14,1.14,0,0,0-.07-.41,1.71,1.71,0,0,0-.21-.35,1,1,0,0,0-.31-.23.81.81,0,0,0-.37-.09h-1.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,336.6V337h-3.2v-4.77h3.14v.42h-2.67v1.72h2.33v.39h-2.33v1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.99,
    y: 77.91,
    width: 572.17,
    height: 8.96,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.11,82.39a2.22,2.22,0,1,1-2.22-2.22A2.23,2.23,0,0,1,96.11,82.39Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.18,82.39A2.22,2.22,0,1,1,103,80.17,2.23,2.23,0,0,1,105.18,82.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,82.39A2.22,2.22,0,1,1,112,80.17,2.23,2.23,0,0,1,114.25,82.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.33,
    y: 86.87,
    width: 9.83,
    height: 337.1,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.24,203.73h0a2.53,2.53,0,0,1-2.54-2.54V91.38a2.54,2.54,0,0,1,2.54-2.54h0a2.54,2.54,0,0,1,2.54,2.54V201.19A2.54,2.54,0,0,1,656.24,203.73Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M584.67,361.83v39.43H624.1V361.83Zm3,36.45V364.81h33.46v33.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 487.4,
    y: 292.92,
    width: 115.36,
    height: 115.36,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.63,408.28h64.18c.27-2.45-9.56-54.6-21.1-71.37-1.31-1.9-12.54-3.29-16.66,1.44C514.23,363.42,509.11,407.68,509.63,408.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.23,341.24c1.82,4.72,8.69,21.26,12.43,33.14,2.5,8,3.46,14.65,4,16.41,0,0-19-6.08-23.22-6.09-6.57,0-17.11,13.7-14.53,15.42,4.07,2.71,23.44,11.9,38.92,14.79,8.41,1.57,24.25-9.12,23-17.62-1.75-11.93-23.31-43.37-31.51-52.29C559.07,340.37,552,335.49,554.23,341.24Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596,399.81c-.4,8.59-11.15,15.83-17.38,16.21-10.75.65-43-8.74-43-8.74l12.53-24.16s22,7.45,22.51,7.66h0c-.19-.64-5.6-21-8-27.69-.13-.37-.28-.75-.42-1.15-.7-1.87-1.65-4.33-2.71-7v0c-.58-1.48-1.2-3-1.81-4.54h0c-2.65-6.58-5.23-12.85-5.23-12.85,3.69.61,7.34,2.55,13.33,8.84S596.65,385.64,596,399.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,402.05c.9-1.71,1.81-3.41,2.7-5.12s1.78-3.34,2.68-5a58.46,58.46,0,0,0,2.65-5.24s0-.07,0,0a44.07,44.07,0,0,0-3,4.75q-1.44,2.5-2.82,5.06t-2.65,5a42.26,42.26,0,0,0-2.42,5.36c0,.08.07.15.12.08A51,51,0,0,0,544,402.05Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.37,394.35l-6.7-3.56h0c-.19-.64-5.6-21-8-27.69-.13-.37-.28-.75-.42-1.15-.7-1.87-1.65-4.33-2.71-7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.91,397.3a54.93,54.93,0,0,0-5.88-3.78c-1-.57-2-1.1-3.1-1.57s-2.32-.87-3.44-1.38c-.09,0-.15.1-.06.13,1,.48,2,1.14,3.05,1.69s2.1,1.13,3.16,1.68c2.09,1.07,4.14,2.21,6.22,3.31C582.91,397.41,583,397.33,582.91,397.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578,392.09c-1.69,0-11.84-2.69-13.32-1.29-9,8.49-11.86,6.78-13.78,7.89-14.85,8.54-34.69,18.58-41.77,18.64-10.73.09-15-8.92-13.22-17.43,3.53-16.83,26.22-49.64,36.49-58.36,5.45-4.62,5,2.35,2.76,9.91-1.32,4.44-3.63,11-6,17.51-2.09,5.77-7.62,20.51-7.72,20.86h0a.08.08,0,0,0,0,0s0,0,.11,0c.48-.09,13.18-6.07,25.95-9.36,4.5-1.16,13.87-2.81,17.23-1.31,2,.89,2,2.09,2,2.09a4.92,4.92,0,0,1,3.3,1.24,4.75,4.75,0,0,1,1.46,2.23,5,5,0,0,1,2.67,1.26,4.57,4.57,0,0,1,1.18,2.49C577.79,389.17,578,392.09,578,392.09Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563,381a24.5,24.5,0,0,0-4,.45c-.09,0-.09.15,0,.14,1.3-.14,2.63-.17,3.94-.21s2.63-.07,3.94-.05h0A21.13,21.13,0,0,0,563,381Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.53,384.7a16.25,16.25,0,0,0-7.09-.63.08.08,0,0,0,0,.15,27.75,27.75,0,0,1,7.09.53S571.56,384.71,571.53,384.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.4,388.46a15.93,15.93,0,0,0-6.72-1.26c-.09,0-.12.13,0,.14a39.09,39.09,0,0,1,6.7,1.22C575.42,388.57,575.45,388.48,575.4,388.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.93,380.68a28.93,28.93,0,0,0-3.32.74c-1.17.29-2.33.6-3.46,1a64,64,0,0,0-6.68,2.65.07.07,0,1,0,0,.13c2.22-.78,4.47-1.51,6.72-2.21l3.3-1.08c1.13-.37,2.31-.65,3.42-1.07C547,380.79,547,380.67,546.93,380.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538,383.09a12.26,12.26,0,0,1,3.42-.8l13.36,22.56s-36.81,13.25-44.36,14a15.07,15.07,0,0,1-16.3-14.67c-.21-13.33,21.54-45.35,32.48-57.74,5-5.67,10.85-9.79,12.34-8.86,1.76,1.1-1.43,8.23-3.12,13.55-3.11,9.83-14.26,38.73-14.26,38.73S535.24,384,538,383.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.34,382.27c-2.08.12-11,3.24-15.44,5.13a76,76,0,0,0-12.55,6.78c-2.23,1.51-4.36,3.15-6.45,4.85a.07.07,0,1,0,.08.12,133.12,133.12,0,0,1,25-13.59c2.51-1,6.83-2.44,9.28-3.08C541.92,382.3,541.4,382.26,541.34,382.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.51,362.54c-.56.9-1.13,1.8-1.61,2.75l-.06.14c.71-2.17,1.39-4.34,2-6.53,0-.13-.18-.2-.23-.07-3.16,8-6.1,16.11-8.95,24.24-.79,2.28-1.49,4.57-2.21,6.87,0,.08.1.12.13,0,.87-2,1.75-3.92,2.54-5.93s1.54-4,2.28-6q2-5.29,3.76-10.65c.37-.62.75-1.25,1.11-1.88.51-.93.94-1.9,1.37-2.87C532.72,362.51,532.57,362.44,532.51,362.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.86,399.93c-1-1.66-1.94-3.33-2.92-5s-1.89-3.27-2.83-4.91a57,57,0,0,0-3.05-5s-.07,0-.06,0a42.67,42.67,0,0,0,2.46,5c.91,1.7,1.85,3.39,2.8,5.07s1.89,3.28,2.86,4.9a43.58,43.58,0,0,0,3.28,4.9c.05.06.16,0,.13-.07A50.1,50.1,0,0,0,545.86,399.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.35,404.9c-1.11-2.19-2.83-4.33-4.11-6.41,0-.08-.16,0-.12.08,1.16,1.95,2.22,4.05,3.33,6-5.05,2.09-10.42,3.95-15.58,5.78s-10.61,3.65-16,5.21c-3,.87-6,1.81-9.07,2.61-.19,0-.14.2.05.16A136,136,0,0,0,530,414.08c5.39-1.71,10.72-3.62,16-5.6C548.94,407.36,555.44,405.07,555.35,404.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.59,380.69a179.9,179.9,0,0,0-18.53,6.11l-.27.1c-3.16,1.24-5.11,2.16-5.58,2.24l-.1-.06h0a4,4,0,0,0-1-.54c-.89-.32-9.44-1.39-9.22-4s3.69-2.45,4.2-2.42c-.55-.12-5.19-1.21-3.68-3.52,1.07-1.65,5.66-1.41,6.13-1.39-.47-.15-4.74-1.54-3.27-3.91,1.05-1.69,6.18-1.47,6.77-1.37-.48-.18-4.28-.82-2.5-2.86,1.23-1.42,10.89,0,15.19,2.17C541.13,374.38,546.59,380.69,546.59,380.69Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.06,386.8l-.27.1a31,31,0,0,0-11.5-4.69c-.28,0-.3-.19,0-.18A21.32,21.32,0,0,1,528.06,386.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.77,377.34c6.08,1.2,8.83,2.55,14.07,5.87.07.05.15-.06.08-.11-4.88-3.65-7.91-5.46-14.1-5.92C518.54,377.16,518.49,377.28,518.77,377.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.25,372c5.84,1.56,8.92,2.9,13.62,6.71.11.09.25,0,.14-.15a21.88,21.88,0,0,0-13.7-6.72C521.93,371.8,521.88,371.91,522.25,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.49,348.59c-3.46,1.24-10.18-3.49-13.09-7.62-.19-.29-.09-3.52-.15-7.45,0-2.39-.16-5-.44-7.46l15.58,2a39.07,39.07,0,0,0-.41,9.45,5.85,5.85,0,0,0,.22,1s0,.1,0,.16C553.76,340.46,554.83,347.39,551.49,348.59Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.24,338.61a2.44,2.44,0,0,1,.08.34c-9.32-.4-12.87-4.5-15.17-8.43-.07-1.5-.17-3-.34-4.46l15.58,2a38.52,38.52,0,0,0-.41,9.45,5,5,0,0,0,.22,1S553.22,338.55,553.24,338.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.43,309.72c-.85,5.59,4.26,20.63,8.57,23.52,6.26,4.19,15.36,3.33,18.63-3.93,3.17-7-3.83-26.52-8.54-29C543.15,296.59,532.68,301.45,531.43,309.72Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.83,316.48s-.06.08,0,.12c.37,1,.62,2.22-.18,2.86,0,0,0,.07,0,.05C546.7,319,546.35,317.38,545.83,316.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.57,315.73c-1.67.42-.71,3.73.85,3.34S546,315.37,544.57,315.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.08,314.6s.1,0,.11.07c.27,1,.75,2.18,1.77,2.25,0,0,0,.05,0,.06C552.79,317.15,552.17,315.63,552.08,314.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.69,313.26c1.62-.6,2.71,2.67,1.21,3.23S551.34,313.77,552.69,313.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.82,314.59a11.68,11.68,0,0,0,1.16-.83c.43-.32.82-.53,1-1.06a.74.74,0,0,0-.36-.82,1.83,1.83,0,0,0-1.8.33,2.66,2.66,0,0,0-1.15,1.54A.77.77,0,0,0,542.82,314.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.49,311.22a13.54,13.54,0,0,1-1.42,0,2.36,2.36,0,0,1-1.46-.23.74.74,0,0,1-.2-.87,1.79,1.79,0,0,1,1.63-.83,2.66,2.66,0,0,1,1.85.52A.78.78,0,0,1,553.49,311.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.21,326c.32.17.66.43,1,.35a2.77,2.77,0,0,0,1-.58,0,0,0,0,1,.06,0,1.45,1.45,0,0,1-1.14.94,1.13,1.13,0,0,1-1.07-.68C548.09,326,548.17,326,548.21,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.4,322.62a3.68,3.68,0,0,0,2.78.88,4.7,4.7,0,0,0,1.28-.31l.23-.1.22-.1a.28.28,0,0,0,.14-.29h0a.42.42,0,0,0,0-.1h0l0-.09c-.21-.79-.63-2-.63-2,.33.07,2,.3,1.85-.11a54.42,54.42,0,0,0-4.44-10.19c0-.11-.22,0-.18.08,1,3.28,2.62,6.35,3.71,9.63a6.42,6.42,0,0,0-1.8,0c-.1.06.86,2.26.93,2.63v0a5,5,0,0,1-3.94-.07C548.37,322.46,548.31,322.56,548.4,322.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.07,320.32c.88-.73,2-4.43,2.52-6s-1.06-8-1.58-9.94a10.52,10.52,0,0,0-2.57,5.35C531.06,312.1,531.79,316.23,533.07,320.32Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.8,306.27a5.14,5.14,0,0,1-4,3,5.27,5.27,0,0,1-4.76-1.89c0-.05-.09,0-.06.05a5.2,5.2,0,0,0,4.86,2.26,5.31,5.31,0,0,0,4.12-3.34C547.94,306.25,547.83,306.2,547.8,306.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.16,295.53a8.08,8.08,0,0,0-5.51,5.48,5.73,5.73,0,0,0,.5,3.78s.12,0,.1,0a6.36,6.36,0,0,1,1.29-6.34,8.17,8.17,0,0,1,6.71-2.83,5.22,5.22,0,0,1,3.29,1.37c.09.09.28,0,.2-.13C544.45,295.25,541.74,294.72,539.16,295.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.61,297a6.56,6.56,0,0,0-3.67-2.63c-2.07-.58-4,.15-5.94.92,0,0,0,.1,0,.08a9.11,9.11,0,0,1,5.1-.87,6.57,6.57,0,0,1,3.75,2.2,6.22,6.22,0,0,1-5.07,10.14c-.06,0-.08.11,0,.11a6.44,6.44,0,0,0,5.8-10Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.39,312.92s-4.18-4.37-2.74-8c.82-2.05,5.17-3,5.17-3a8,8,0,0,1,4-4.67c3.35-1.84,8.21-1,8.21-1s2.86-2.91,6.57-2c5.17,1.29,6.53,8.23,2.66,11.67-2.71,2.42-7.77.84-7.77.84-.4.18-3.89,3.9-8.13,1,0,0-1.93,3-4.71,2.08A3.88,3.88,0,0,1,531.39,312.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.59,321.83s-4.32-4.4-6.37-2.78,1.78,8.41,4.6,8.95a2.72,2.72,0,0,0,3.37-2.05Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.36,321s0,.07,0,.07c2,.45,3.26,2,4.25,3.68a1.52,1.52,0,0,0-2.3,0s0,.11.06.09a1.7,1.7,0,0,1,1.93.27,7.59,7.59,0,0,1,1.12,1.34c.12.15.4,0,.31-.17l0,0C536.35,323.79,534,320.78,531.36,321Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.19,338.28l-3.31,9.17-11.6-10.95-3,3.77s11.61,17.65,11.64,16.83l3.41-7.89,5.55,5.19-1-13.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.77,347.69c-.23-2.22-.4-4.47-.74-6.68,0-.08-.13-.11-.15,0-.36,2.17.57,10.68.64,12.72l0,0c-.23-.22-5.13-4.55-5.18-4.48-.75,1.26-3.26,7-3.42,7.53-1.84-2.81-8.86-13-11-15.62a.08.08,0,0,0-.13.08c1.64,3,10.93,16.69,11.06,16.64a85.4,85.4,0,0,0,3.56-8.33c.84.95,5.81,5.85,5.82,5.52A72.08,72.08,0,0,0,555.77,347.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.46,
    y: 235.33,
    width: 117.98,
    height: 121.81,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.69,271.7v62.64h62.64V271.7Zm4.73,57.91V276.43H390.6v53.18Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.28,269.59c3.1-.73,11.14,1.37,13.89,5.48s2.62,10.84,1.25,11.52-7.31.26-11.41-1.92S437.75,270,439.28,269.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27,269.61c-.1,0-.12-.19,0-.2,2.73-.11,5.66.77,8.27,1.48a15.79,15.79,0,0,1,6,2.65,7.3,7.3,0,0,1,2.74,5.48,14.92,14.92,0,0,1-1.32,7.46c0,.06-.15,0-.13,0,1.19-4.56,2.2-10.12-2.36-13.14C448.58,270.73,443.67,270.5,439.27,269.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454,285.41c2.73.31,9.89,5.39,11.15,10.55s-2.82,12.88-4.14,13.45-7.42-4.3-9.44-7.91c-1.35-2.42-.36-5.27.2-8.11C452.53,289.21,453.53,285.37,454,285.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.88,300.87c-.89-5.26,2-10.53,3.74-15.32,0-.05.1,0,.09,0-.92,4.59-3.61,8.74-3.62,13.52a8.73,8.73,0,0,0,3.4,7.31c2.05,1.48,4.61,2.13,7,2.93.16.05.06.28-.1.23C455.65,308.1,450.79,306.31,449.88,300.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.55,285.89a.12.12,0,0,1,.09-.22c3.9,1.78,8.6,4.38,10.73,8.27,2.31,4.22.13,8.7-1.81,12.57,0,0-.1,0-.08,0,1.91-3.92,3.92-8.78,1.31-12.88C462.54,290.06,458.23,287.63,454.55,285.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.64,309.28a11.66,11.66,0,0,0-4.27,8.18c-.4,6.32-2.87,5.33-9.49,7.67-5.6,2-6.17,8.53-2.79,11.39,0,0-2.17-3.78,1.5-6.11,4.38-2.79,15.45,1,20.06-6.07C471.61,315.2,460.64,309.28,460.64,309.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.5,312.4c.06-.09-.09-.21-.17-.12a9.5,9.5,0,0,0-1.59,2.89c-.45,1.38-.33,2.81-.68,4.19-.89,3.54-5,3.84-8,4.35-4,.69-6.95,3.46-6.76,7.7a0,0,0,0,0,.09,0,7.15,7.15,0,0,1,3.63-6.47c2.24-1.23,4.93-1,7.3-1.81,1.62-.57,3.2-1.44,3.81-3.14a14.22,14.22,0,0,0,.46-2.92A9.88,9.88,0,0,1,458.5,312.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.77,309.93s-.08,0,0,.06c2.5,2,5.12,4,6.11,7.22,1.06,3.45-.4,7.16-2.95,9.57-2.86,2.69-6.3,1.89-9.83,1.57a14.34,14.34,0,0,0-7.51.83c-.07,0,0,.16.06.13,3.87-1.32,7.61-.51,11.56-.27a7.86,7.86,0,0,0,7.41-3.84C470.53,319.3,467.13,313.37,461.77,309.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.62,266.7a1.09,1.09,0,0,1,1.71,1.34C442.48,269.16,440.77,267.82,441.62,266.7Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.81,268.55a1.09,1.09,0,0,1,1.71,1.34C441.67,271,440,269.67,440.81,268.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.68,270.25a1.09,1.09,0,0,1,1.71,1.34A1.09,1.09,0,0,1,439.68,270.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.37,271.74a1.09,1.09,0,0,1,1.71,1.34C439.23,274.2,437.52,272.86,438.37,271.74Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.79,273c.85-1.12,2.56.22,1.71,1.34A1.09,1.09,0,0,1,436.79,273Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.07,274a1.09,1.09,0,0,1,1.71,1.34C435.93,276.4,434.23,275.06,435.07,274Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44,294.1c-4.69,5.78-29.8,24-51,23.64-7.2-.11-27.2-30.84-30.9-42.52-2.65-8.39,15.16-12.63,20.2-11.42,6.28,1.52,18.52,27.87,20.94,28,7.2.5,19.56-3.83,34.73-5.37C435.22,285.68,437.06,289.66,433.44,294.1Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.25,277.15c-1.34-2.92-7.63-19.15-8.14-23.32s-1.1-16.31,2.06-17,3.61,2.83,3.61,2.83.56-5.17,3.81-5.6,3.78,5.1,3.78,5.1,1-5.26,4.23-5.46,2.87,5.45,2.87,5.45.65-4.85,3.41-3.88c3.33,1.17,1.11,10,2,14.54.21,1,5.68,20.74,5.68,20.74Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.49,238.64c-1.61,6.47-1.2,9.59.86,15.83,0,.12-.13.21-.18.08-2.58-5.92-3.66-9.75-1-16C364.31,238.24,364.57,238.33,364.49,238.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.5,238.62c-1.08,6.87-.66,10.25,1,16.95,0,.09-.13.14-.16.05-2.2-6.43-3.19-10.28-1.2-17C357.24,238.31,357.55,238.3,357.5,238.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.88,240c-.57,6.74-.27,10.46,2.19,16.75a.13.13,0,0,1-.23.11c-3.13-6.17-3.54-10.82-2.17-16.85C349.77,239.56,349.92,239.54,349.88,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,273.57s.93-8.31.53-12.05-7-17.14-10-15.88c-3.84,1.63-1.55,10.12.12,14.13,0,0-8.89,3.77-8.56,10.22S380,273.57,380,273.57Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.65,246.44c-2.43,4,.1,9.13,1.43,13.14a.39.39,0,0,1-.36.53c-3.62,1.83-8.2,5.46-8.8,9.7a.1.1,0,0,1-.19,0c0-4.64,4.23-8.57,8.32-10.32-1.42-4.09-3.73-9.34-.43-13.07C369.63,246.39,369.67,246.41,369.65,246.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,289.8,412.17,310s13.22-6.29,21.26-14.42-.9-10.86-8.68-9.68S403.43,289.8,403.43,289.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.43,295.62c-8,8.13-21.26,14.42-21.26,14.42l-2.66-6.15,26.63-15.44C437.12,290.07,436.58,292.43,433.43,295.62Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.47,307.2a155,155,0,0,1-7.55-17.37c0-.07.09-.12.12,0,.59,1.56,4.75,10.16,7.56,17.36C415.64,307.24,415.51,307.28,415.47,307.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.4,329.76l-3.59,27.38h57.31S459.54,305.79,447.3,290c-6.12-7.89-14.32-7.68-20.12-1.65-1.27,1.31-14.07,19.6-16.33,27.15C408.88,322.19,413.4,329.76,413.4,329.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.08,291.11l-3.62,9.71q-1.79,4.86-3.44,9.75c-1,3.28-2.25,6.56-1.76,9.9a25.21,25.21,0,0,0,3.25,9.54l.08.14v.14c-.5,4.35-1.09,8.7-1.62,13s-1.14,8.69-1.76,13q.56-6.56,1.19-13.09c.44-4.36.84-8.72,1.32-13.07l.06.27a26,26,0,0,1-3.49-9.89,14.34,14.34,0,0,1,.37-5.3c.44-1.7,1-3.35,1.53-5,1.11-3.29,2.42-6.49,3.73-9.69S428.62,294.25,430.08,291.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.08,303.76a.86.86,0,0,0,.63,1,.79.79,0,0,0,.9-.7.85.85,0,0,0-.63-1A.78.78,0,0,0,422.08,303.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.61,313.21a.85.85,0,0,0,.63,1,.78.78,0,0,0,.89-.69.85.85,0,0,0-.63-1A.78.78,0,0,0,418.61,313.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.17,322.85a.85.85,0,0,0,.63,1,.79.79,0,0,0,.9-.69.86.86,0,0,0-.63-1A.79.79,0,0,0,418.17,322.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.85,330.84a.85.85,0,0,0,.63,1,.79.79,0,0,0,.9-.69.86.86,0,0,0-.63-1A.79.79,0,0,0,420.85,330.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.81,339.55a.86.86,0,0,0,.63,1,.78.78,0,0,0,.89-.7.86.86,0,0,0-.63-1A.78.78,0,0,0,419.81,339.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.86,348.15a.86.86,0,0,0,.63,1,.79.79,0,0,0,.9-.7.85.85,0,0,0-.64-1A.77.77,0,0,0,418.86,348.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.34,387.13c2.89,2,7.75-6.68,9.4-8.53s2.37-1.79,2.27-.38l3.76-14.92c-1.95,1.51-6.08,4.76-8.28,6.9C434.54,373.06,427.45,385.17,430.34,387.13Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452,292.22c12.24,9.87,27.67,27.23,30.82,38.45,2.42,8.66-9.76,38.75-13.39,45.77-1.58,3.06-22.54-6.25-23.46-9.82s13.69-29.48,13.83-32.23-9.41-20.91-15.92-33.19C435.93,286.32,441.54,283.83,452,292.22Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.4,395.7c1.93,2.1,5.84-.45,5.84-.45s-3.48,4.3-.76,6,6.43-2,6.43-2-3,4.12-.15,5.58,6.49-1.73,6.49-1.73-.2,1.58,2.27,1.72c3.54.2,8.59-5.54,10.52-9.16s6.31-18.31,6.95-20.57l-23.15-12.58s-.41.3-1.07.82L442,378.22c-.06.93-2.71,6.66-3.67,8.31C436.17,390.24,430.23,393.34,432.4,395.7Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36,395c5.19-3.93,6.78-6.54,9-12.54,0-.12.23-.08.19.05-1.67,6.07-3.19,9.64-9.05,12.76C438.25,395.46,438.11,395.23,438.36,395Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.65,399.34c5-4.56,6.78-7.38,9.61-13.49,0-.09.19,0,.15.06-2.26,6.23-3.86,9.75-9.49,13.64C443.67,399.73,443.42,399.54,443.65,399.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.27,403c4.55-4.76,6.6-7.78,8.58-14.06a.12.12,0,0,1,.24.06c-1.4,6.6-3.93,10.38-8.66,14.12C450.1,403.36,450,403.28,450.27,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.65,319.23,467.32,306s-9.18-11.4-18.95-17.34S438,292.08,441,299.38,449.65,319.23,449.65,319.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.79,303.49a156.67,156.67,0,0,1-15.15,11.37c-.06,0-.13-.06-.07-.11,1.39-.94,8.79-7,15.15-11.38C463.79,303.32,463.86,303.43,463.79,303.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.54,311.75c-1.07-2.41-2.54-5.92-3.76-8.27,0,0-.07,0-.06,0,.48,1.37,1,2.74,1.59,4.09a2.39,2.39,0,0,0-.13-.21c-.44-.63-.9-1.25-1.39-1.85,0,0,0,0,0,0,.37.68.77,1.35,1.2,2,.27.41.56.8.85,1.19.31.71,1,2.47,1.33,3.18.52,1.19,3.06,7.89,3.17,7.81a18.28,18.28,0,0,0,1.78-1.33c.09-.07,0-.23-.13-.16-.32.27-1.12.8-1.25.9-.57-1.21-1-2.49-1.57-3.73S447.09,313,446.54,311.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.11,286.23c-.3,1-5.57,7.44-10.26,7-1.53-.16-1.05-8.54-1.05-8.54l-.11-.62-1.48-8.78,10.54-6,1.52-.78s.24,2.43.52,5.45c0,.14,0,.28,0,.43s0,.33.05.49c.05.46.09.92.13,1.38s.06.69.08,1.06,0,.73.07,1.1A57.94,57.94,0,0,1,439.11,286.23Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.79,273.93A17.89,17.89,0,0,1,427.69,284l-1.48-8.78,10.54-6,1.52-.78S438.51,270.91,438.79,273.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.22,259.81c-3.18,15.29,5.63,18.92,8.92,19.6,3,.61,13.27,2.34,18-12.55s-1.37-21.19-8.15-23S418.39,244.51,415.22,259.81Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.38,256.2a9.75,9.75,0,0,0,1.08,0,1.8,1.8,0,0,0,1.09-.25.56.56,0,0,0,.11-.67,1.39,1.39,0,0,0-1.29-.55,2,2,0,0,0-1.37.5A.59.59,0,0,0,420.38,256.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.89,258.55c-.35-.11-.66-.26-1-.4a1.81,1.81,0,0,1-.95-.6.55.55,0,0,1,.12-.67,1.38,1.38,0,0,1,1.39-.09,2,2,0,0,1,1.13.92A.6.6,0,0,1,430.89,258.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.19,261.86s.07.06.06.1c-.24,1-.33,2.27.55,2.8,0,0,0,.07,0,.06C427.66,264.43,427.8,262.8,428.19,261.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.33,261c1.7.19,1.18,3.59-.39,3.4S427.9,260.78,429.33,261Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,261.23c.26.23.5.62.86.71s.77-.21,1.09-.51c0,0,.06,0,.05.05-.09.65-.44,1.28-1.15,1.27s-1-.65-1.08-1.33C429.73,261.29,429.86,261.13,430,261.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.76,260.39c0-.05-.09,0-.09.08-.12,1-.44,2.25-1.44,2.46,0,0,0,.06,0,.06C421.42,263,421.82,261.41,421.76,260.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,259.15c-1.67-.37-2.3,3-.75,3.35S422.38,259.46,421,259.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.24,259.24c-.3.13-.63.41-.95.37s-.58-.46-.75-.85c0,0-.05,0-.06,0-.14.65-.05,1.36.55,1.6s1.06-.26,1.33-.88C420.41,259.39,420.36,259.19,420.24,259.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,269.86c-.28.22-.57.54-1,.53a2.84,2.84,0,0,1-1.11-.39,0,0,0,0,0-.05.05,1.44,1.44,0,0,0,1.28.72,1.14,1.14,0,0,0,.94-.85C425.92,269.86,425.84,269.83,425.8,269.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,265.35s-.48,1.53-.6,2.27c0,.07.16.13.41.19h0a3.55,3.55,0,0,0,3.63-.75c.06-.06,0-.15-.09-.12a5.35,5.35,0,0,1-3.36.39c0-.21.9-2.59.78-2.62a6.59,6.59,0,0,0-1.74.1c.9-3.22,2.3-6.27,3.15-9.49a.1.1,0,0,0-.19-.07,53.86,53.86,0,0,0-3.82,10.07C420.11,265.73,421.72,265.42,422,265.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.86,245.83a6.88,6.88,0,0,0-.19,4c1.32,3.61,5.57,3.1,6.86,4.6s.49,4,1.57,5.41c1.51,1.93,3.85,1.46,4,2.68s.59,5.1,2.07,5.73,10.86-24-9.1-25.08c0,0-2.62-1.37-7.06.35-4.89,1.91-7.66,9.4-7.66,9.4s.11-.1.85-.63c1-.76,1.48-1.5,2.24-2,1.19-.75,1.76-.37,3-1.1A13.18,13.18,0,0,0,426.86,245.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.27,244.76a12.69,12.69,0,0,0-.87,3,5.53,5.53,0,0,0,.14,3,4.1,4.1,0,0,0,2.11,2c.91.44,2,.64,2.93,1.14a3.17,3.17,0,0,1,1.23,1.13,4.08,4.08,0,0,1,.44,1.59,5.54,5.54,0,0,0,.84,2.85,3.47,3.47,0,0,0,2.56,1.38,7.29,7.29,0,0,1,3.07.45,7.39,7.39,0,0,0-3.08-.21,3.8,3.8,0,0,1-2.85-1.38,5.62,5.62,0,0,1-1-3,3.92,3.92,0,0,0-.4-1.41,2.7,2.7,0,0,0-1.07-.93c-.87-.47-1.92-.7-2.88-1.17a5.62,5.62,0,0,1-1.35-.91,3.35,3.35,0,0,1-.93-1.35,5.83,5.83,0,0,1,0-3.18A13.19,13.19,0,0,1,427.27,244.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.8,245.63a11.15,11.15,0,0,1-1.22,2.65,5.16,5.16,0,0,1-2.21,2,7.64,7.64,0,0,1-1.42.4,2.43,2.43,0,0,0-1.15.62,7.51,7.51,0,0,1-1,1.09,3.14,3.14,0,0,1-1.34.61,3.41,3.41,0,0,0,1.17-.79,8,8,0,0,0,.85-1.15,2.45,2.45,0,0,1,1.31-.82,8,8,0,0,0,1.35-.41,5.39,5.39,0,0,0,2.08-1.78A20.76,20.76,0,0,0,426.8,245.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.05,266.08s4.11-4.31,6.11-2.78-1.59,8.14-4.3,8.71a2.65,2.65,0,0,1-3.29-1.94Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.08,265.17s0,.06,0,.07c-1.92.46-3.12,2-4,3.61a1.45,1.45,0,0,1,2.21-.06c.05,0,0,.1-.06.08a1.61,1.61,0,0,0-1.85.3,7.48,7.48,0,0,0-1.07,1.3c-.11.15-.38,0-.29-.16l0,0C438.31,268,440.58,265,443.08,265.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.68,285.35l2.21,7.12,9.28-8,2.2,3s-9.5,13.18-9.51,12.55l-2.36-6.17-4.43,3.8,1.17-10.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.36,292.46c.25-1.7.45-3.42.78-5.11,0-.06.11-.08.12,0,.21,1.68-.79,8.19-.91,9.76l0,0c.19-.16,4.1-3.33,4.13-3.27.54,1,2.28,5.49,2.39,5.9,1.5-2.1,7.23-9.69,9-11.65.05-.05.14,0,.1.07-1.36,2.23-9,12.47-9.06,12.43a68.32,68.32,0,0,1-2.46-6.53c-.68.71-4.66,4.32-4.65,4.06A53.41,53.41,0,0,1,425.36,292.46Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 487.4,
    y: 155.37,
    width: 129.39,
    height: 129.39,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.57,122.58v87.17h87.17V122.58ZM625,205H547.3V127.31H625Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.19,232.25l7,.49A21.6,21.6,0,0,0,540,220c-.08-1,2.05,4.9.73,13,7.39.51,17.45,1.21,26.23,1.74.33-3.43.79-6.59.79-6.59a38.38,38.38,0,0,0,1.13,6.71c1.2.08,2.38.14,3.51.2a132.3,132.3,0,0,1,1.32-14.59,46.91,46.91,0,0,0,3.67,14.86c5.59.28,9.26.36,9,.08-8-10.07-1.56-15.37-3.58-24-2.41-10.35-11.15-12.38-10.54-20,.49-6.24,1.78-17.53-6-20.32A15.21,15.21,0,0,0,550,167.12c-12.69,4.2-8.63,23.69-9.66,27.57-1.47,5.54-4.23,7.39-6.51,13.69s.43,10.79.56,15.18S528.79,232.17,530.19,232.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.75,234a22,22,0,0,1-2.46-5.59,11.52,11.52,0,0,1,.29-5.87,58.64,58.64,0,0,0,1.31-6.12,16.22,16.22,0,0,0-.32-6.46,14.31,14.31,0,0,0-3.11-5.7,37.88,37.88,0,0,0-4.61-4.29,23.11,23.11,0,0,1-4.25-4.31,11.31,11.31,0,0,1-2-5.69,10.55,10.55,0,0,0,1.34,6.09,21,21,0,0,0,4.07,4.82,47.2,47.2,0,0,1,4.27,4.35,13.7,13.7,0,0,1,2.69,5.15,16.14,16.14,0,0,1,.32,5.85c-.21,2-.67,4-1,6a20.77,20.77,0,0,0-.34,3.18,9.1,9.1,0,0,0,.56,3.2A17.91,17.91,0,0,0,586.75,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.59,174a31.19,31.19,0,0,0-2,7.38c-.43,2.51-.74,5-1,7.57l-.45,3.77a18.88,18.88,0,0,1-.73,3.59,20.46,20.46,0,0,1-3.7,6.3,28.7,28.7,0,0,0-2.19,3.24,17.46,17.46,0,0,0-1.56,3.67,27.19,27.19,0,0,0-.73,3.87,16.4,16.4,0,0,0,0,4c.17,1.31.48,2.56.73,3.78a20.06,20.06,0,0,1,.42,3.69,7.85,7.85,0,0,1-3.36,6.31,8,8,0,0,0,4.15-6.28,19.53,19.53,0,0,0-.15-3.9c-.17-1.28-.43-2.52-.51-3.74a20,20,0,0,1,.91-7.24,17.44,17.44,0,0,1,1.46-3.31,27.7,27.7,0,0,1,2.11-3.05,36.08,36.08,0,0,0,2.23-3.19,16,16,0,0,0,1.65-3.64,20.62,20.62,0,0,0,.68-3.89c.13-1.28.21-2.55.29-3.82.17-2.54.3-5.07.54-7.59A36.51,36.51,0,0,1,542.59,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.64,281.21c0-.15,0-.3-.08-.45a5.43,5.43,0,0,1,.09.56A.41.41,0,0,0,603.64,281.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.6,285.64a1.59,1.59,0,0,0,.26.14l0-.07h0l-.27-.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.82,215.64c-15.72,17.68-34.75,54.15-30.48,61.12,4.75,7.76,27.42-17.42,26.64-18.56-.66-1,6.71-22.78,12.07-38.73S546.71,211.27,542.82,215.64Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.82,215.64c-15.72,17.68-34.75,54.15-30.48,61.12,4.75,7.76,27.42-17.42,26.64-18.56-.66-1,6.71-22.78,12.07-38.73S546.71,211.27,542.82,215.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.94,237.77c-1.54,4.65-2.94,9-4,12.5-2.43.11-9.54-.28-16.92-7.38,2.22-3.93,4.62-7.88,7.1-11.66A22.1,22.1,0,0,0,544.94,237.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.66,284.82l3.94-26.75s-6.32-11-2.65-19c1.85-4,14.56-23.64,21.4-28.61,6.42-4.66,15.22-.41,18.21,3.64,8.6,11.66,12.79,32.64,17.59,70.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.17,222.82c-1.3,1.78-2.56,3.59-3.8,5.42.34-.71.68-1.42,1-2.13,0-.05,0-.1-.07,0-.46.89-.89,1.79-1.3,2.7q-2.49,3.67-4.82,7.46a19.84,19.84,0,0,0-1.71,3.34,14.94,14.94,0,0,0-.83,3.54,17.81,17.81,0,0,0-.06,3.65,24.38,24.38,0,0,0,.53,3.71,23.13,23.13,0,0,0,1.3,4.06c.28.64.57,1.27.89,1.9s.87,1.72.87,1.76c-.12.64-.24,1.09-.32,1.63s-.17,1.1-.25,1.65c-.17,1.1-1.59,11.78-1.75,12.88-.32,2.18-.6,4.36-.87,6.55-.15,1.26-.24,2.52-.41,3.77,0,.05.07.07.08,0,.18-1.09.45-2.16.64-3.25s.4-2.18.61-3.27c.41-2.2,2-14,2.34-16.21.1-.61.19-1.22.29-1.84a11.59,11.59,0,0,0,.23-2,49.16,49.16,0,0,1-2.72-6.84,24.06,24.06,0,0,1-.77-3.64,18.94,18.94,0,0,1,0-3.61,16.4,16.4,0,0,1,.69-3.55,19.07,19.07,0,0,1,1.54-3.38c1.28-2.27,2.64-4.5,4-6.71q2.34-3.76,4.76-7.49S539.2,222.78,539.17,222.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.34,276.76c4,5.15,14.23,5.64,39.85,9.28,3.54.51,13.83-23.55,10.07-24.28-4.73-.93-23.3-3.49-24.68-3.5C525.93,258.12,509.61,273.27,512.34,276.76Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.13,260.86s10.83,1.07,16.35,3.39A38.47,38.47,0,0,1,588,275.61c4.16,5.27,10.56,20.9,6.38,23.53-3.78,2.38-9.52-13.93-9.52-13.93s8.59,15.66,3.51,17.69-10.67-17.28-10.67-17.28,8.47,16.29,2.9,17.55c-4.21,1-10.25-16.24-10.25-16.24s7.18,14.05,2.89,15.21c-4.74,1.29-11.31-14.23-11.31-14.23-11.4,1.13-17.3-3-21.14-6.43C539.81,280.65,557.13,260.86,557.13,260.86Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.18,279.61c1.08,1.8,2.18,3.62,3.09,5.51s1.76,3.82,2.49,5.79a35.22,35.22,0,0,1,2.12,7.93c-1.06-4.77-4.22-11.59-5.14-13.49s-1.72-3.82-2.63-5.71A0,0,0,1,1,582.18,279.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.29,282.78c1.27,2.36,2.63,4.66,3.8,7.07s2,4.8,3,7.28c.08.19,0,.17-.14,0-1.09-2.44-2.29-4.61-3.41-7s-2.15-4.89-3.36-7.27C575.21,282.76,575.27,282.74,575.29,282.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.88,284.43a59.35,59.35,0,0,1,5,11.27c.07.19-.09.15-.17-.05-1.59-3.77-2.8-6.75-4.93-11.14C568.73,284.44,568.84,284.36,568.88,284.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.31,261.05l-21.09,24.82s-28.8-2-32.12-9.6,18.61-18.65,25.45-18S565.31,261.05,565.31,261.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.45,261.51c1.66-1.14,6.36-3.82,11.1-3.29a0,0,0,0,1,0,.08c-3.89.12-9.37,2.31-11.06,3.27C526.45,261.6,526.41,261.53,526.45,261.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.76,281.58c8.29-8.78,15.67-19.27,17.09-21,.06-.08-.08-.18-.14-.1-1.3,1.78-11,12.85-17.1,21C539.54,281.57,539.68,281.66,539.76,281.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.43,
    y: 235.93,
    width: 46.73,
    height: 35.89,
    transform: "translate(175.89 723.18) rotate(-78.46)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 527.08,
    y: 228.62,
    width: 17.01,
    height: 5.16,
    transform: "translate(57.44 -102.99) rotate(11.6)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "540.65 229.61 538.6 229.18 539.07 226.86 534.09 225.83 533.61 228.16 531.56 227.74 532.43 223.5 541.55 225.37 540.65 229.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.77,219.68C589.71,241.23,596.1,280,586.7,283c-8.59,2.76-43.92-6.08-54.45-9.66-3.09-1.05,6.46-25.08,9.77-24,4,1.35,25.84,6.53,26.27,6.54.91,0-3.95-23.82-6-34.63C559.35,206.21,566.41,211.58,572.77,219.68Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.77,240.32a3.87,3.87,0,0,0-.34,4.42,5.78,5.78,0,0,0-3.15,2.34c-1.22,2,1.45,4.85,1.45,4.85a7.09,7.09,0,0,0-2.93,3c-1,2.07,1.32,5.29,1.32,5.29a6.21,6.21,0,0,0-.92,4.25c.74,3.94,6.43,6.18,10,7.64s15.2,2.21,17.39,2.58l9.56-23.07s-14.31-11.13-18.8-12.25C523.62,238.43,515.78,238,513.77,240.32Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.74,244.44c4.26,0,8.27,1.32,12.35,2.38.09,0,0,.16,0,.14-4-1.1-8.26-1.38-12.34-2.32A.1.1,0,0,1,513.74,244.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.93,251.66a11,11,0,0,1,2.82.67c1,.31,2,.63,2.92,1,2,.68,3.87,1.41,5.78,2.19.08,0,0,.17,0,.14q-2.91-1-5.85-1.91c-1-.3-2-.59-2.95-.87a13.36,13.36,0,0,1-2.76-.92A.15.15,0,0,1,511.93,251.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.2,260.23a7.81,7.81,0,0,1,2.51.75c.87.33,1.76.65,2.64,1,1.76.63,3.53,1.27,5.31,1.84a.08.08,0,0,1,0,.15c-1.81-.58-3.64-1.13-5.45-1.72l-2.66-.89a7,7,0,0,1-2.35-1A.06.06,0,0,1,510.2,260.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568,254.91c.27-.17-4.8-23.17-6.5-35.18s3.66-10.85,11.37-.59c8.27,11,23,40.76,17.89,62.8-1.65,7.14-52.78-2.86-52.78-2.86l6.89-29.39S567.55,255.16,568,254.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.81,252.73c-8.34,2.44-17.39,1.2-21.08.51-.53-2.89-1.82-9.15-3.14-15.91,8.76,1,14.7-.28,17.95-1.37A113.59,113.59,0,0,1,588.81,252.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.64,276.06c3.11-10.24,4.82-21.46,5.26-23.4,0-.09-.13-.11-.14,0-.33,1.92-3.69,14.54-5.28,23.39C544.46,276.13,544.61,276.15,544.64,276.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.58,258.31c-1-.17-27.09-7.52-32.79-8.41-.09,0,0-.31.08-.29a241.07,241.07,0,0,1,33.06,8.22C579.23,258.35,579.42,258.63,577.58,258.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.72,255.14s-1.72-8.86-2-9.41-1-1.83-1.28-2.42c-.57-1.19-1.06-2.41-1.58-3.62,0-.1.11-.17.15-.07.57,1.16,1.23,2.28,1.9,3.39.33.54.66,1.09,1,1.62,0,0-1.61-8.6-1.84-10.12,0-.11.1-.15.14,0,.49,1.53,3.91,18.84,4.38,20.76A6,6,0,0,1,567.72,255.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.48,280.9c-1.71-.47-8.54-1.57-10.2-1.81a21.62,21.62,0,0,0,.6-3.74.08.08,0,0,0-.14,0,29.94,29.94,0,0,0-1.25,4.28c0,.14,9.2,1.3,11,1.39C548.51,281,548.53,280.92,548.48,280.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.19,212.63s.68,6.76,6.29,7.81,16.08-6.31,16.08-6.31a15.61,15.61,0,0,0-11.81-5.68C549.44,208.44,546.19,212.63,546.19,212.63Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.28,210.74c-.3,1-5.59,7.42-10.28,6.93-1.53-.17-1-8.55-1-8.55l-.1-.62-1.45-8.78,10.56-6,1.52-.78s.24,2.43.5,5.46c0,.14,0,.28,0,.43s0,.33.05.49c0,.45.09.91.12,1.37s.06.7.08,1.06l.06,1.1A57.7,57.7,0,0,1,562.28,210.74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562,198.44a17.88,17.88,0,0,1-11.13,10.06l-1.45-8.78,10.56-6,1.52-.78S561.75,195.41,562,198.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.28,183.33c-4.11,15.06,4.46,19.23,7.71,20.11,3,.8,13.09,3.15,18.74-11.41s-.06-21.24-6.72-23.43S543.39,168.26,539.28,183.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.71,180.38c.37,0,.71,0,1.08,0a1.74,1.74,0,0,0,1.1-.18.54.54,0,0,0,.16-.66,1.37,1.37,0,0,0-1.24-.63,2,2,0,0,0-1.41.4A.6.6,0,0,0,544.71,180.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.45,181.88a8.68,8.68,0,0,1-1-.45,1.72,1.72,0,0,1-.92-.64.55.55,0,0,1,.15-.66,1.35,1.35,0,0,1,1.4,0,2,2,0,0,1,1.08,1A.59.59,0,0,1,555.45,181.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552,186.7s.06.07,0,.11c-.29,1-.44,2.25.41,2.82,0,0,0,.07,0,.05C551.34,189.24,551.57,187.62,552,186.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.19,185.85c1.7.28,1,3.65-.56,3.38S551.78,185.61,553.19,185.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.82,186.16c.25.25.47.65.82.76s.78-.17,1.12-.45c0,0,.06,0,0,.05-.13.65-.51,1.26-1.22,1.21s-1-.71-1-1.39C553.58,186.22,553.72,186.06,553.82,186.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.8,184.64s-.09,0-.1.08c-.19,1.05-.58,2.21-1.6,2.35,0,0,0,.06,0,.06C545.28,187.22,545.79,185.67,545.8,184.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.11,183.36c-1.65-.49-2.5,2.84-1,3.29S546.49,183.77,545.11,183.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.36,183.4c-.31.11-.65.36-1,.3s-.55-.5-.69-.9c0,0-.05,0-.06,0-.18.63-.14,1.35.44,1.63s1.07-.19,1.39-.78C544.53,183.56,544.48,183.36,544.36,183.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.34,194.58c-.29.2-.59.5-1,.47a2.84,2.84,0,0,1-1.08-.44s-.07,0-.06,0a1.45,1.45,0,0,0,1.24.79,1.15,1.15,0,0,0,1-.8C549.46,194.58,549.39,194.55,549.34,194.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.82,189.87s-.55,1.51-.71,2.24c0,.07.15.14.4.21,0,0,0,0,0,0a3.53,3.53,0,0,0,3.66-.56c.07-.06,0-.15-.09-.12a5.34,5.34,0,0,1-3.37.21c0-.21,1-2.54.92-2.58a6.45,6.45,0,0,0-1.75,0c1.07-3.17,2.63-6.14,3.64-9.31,0-.12-.13-.19-.18-.09a53.93,53.93,0,0,0-4.34,9.86C543.87,190.15,545.5,189.93,545.82,189.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.8,192.09a4.25,4.25,0,0,0,1.29,1.7,1.91,1.91,0,0,0,1.1.37c.86,0,1.08-.74,1.1-1.41a4.52,4.52,0,0,0-.1-1.06A5.53,5.53,0,0,1,545.8,192.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.09,193.79a1.91,1.91,0,0,0,1.1.37c.86,0,1.08-.74,1.1-1.41A2,2,0,0,0,547.09,193.79Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.89,191.78c-1.61-.57-4.58-6.29-2.44-14.22,0,0-1.43,7.26-1.19,8.45s-1.66-3.22,0-9.64a26.75,26.75,0,0,1-7.51,1.52c-3.24,0-5.08-.58-5.23-.86s4.67-.4,6.26-1.44c0,0-9.06,1.43-12.83.65-.43-.09,1.57-9,8.34-11.09s14.64,4.52,16.4,7.56c0,0,2.73,1.22,4.62,6.33S566.62,192.39,564.89,191.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.56,192.11s4.22-4.19,6.18-2.6-1.83,8.09-4.55,8.57a2.64,2.64,0,0,1-3.23-2Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.61,191.35s0,.06,0,.07c-1.92.4-3.17,1.89-4.14,3.49a1.45,1.45,0,0,1,2.22,0s0,.1-.07.08a1.62,1.62,0,0,0-1.86.24,8.29,8.29,0,0,0-1.1,1.27c-.12.15-.39,0-.29-.16l0,0C562.76,194,565.11,191.13,567.61,191.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.63,285.65l.26.06h0Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.56,280.76a5.43,5.43,0,0,1,.09.56.41.41,0,0,0,0-.11C603.62,281.06,603.59,280.91,603.56,280.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.56,280.76a5.43,5.43,0,0,1,.09.56.41.41,0,0,0,0-.11C603.62,281.06,603.59,280.91,603.56,280.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.45,288.37h0l.81.19Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.56,280.76a5.43,5.43,0,0,1,.09.56.41.41,0,0,0,0-.11C603.62,281.06,603.59,280.91,603.56,280.76Z",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.65,113.62V153h39.43V113.62Zm3,36.44V116.59H354.1v33.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.67,
    y: 103.55,
    width: 133.77,
    height: 123.19,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.45,164.64c16.3,16.52,36.8,51.27,33,58.32-4.26,7.85-26.95-15.31-26.87-16.67.07-1-7.91-22.13-14-37.48S432.42,160.55,436.45,164.64Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.41,206.32c-.69-2.26-11.56-30.09-14.66-38.9s-.23-11.52,8.64-3.46,28.31,35,32.75,49.29C473.41,227,466.32,227,457,220.67,449.31,215.48,442.41,206.32,442.41,206.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.85,164.87a7.19,7.19,0,0,1-1.54,3.36,6.81,6.81,0,0,1,.55-1.78A7.08,7.08,0,0,1,434.85,164.87Zm26.88,38.28a6.25,6.25,0,0,0-.55,1.78,6.54,6.54,0,0,0,1-1.58,6.81,6.81,0,0,0,.55-1.78A6.25,6.25,0,0,0,461.73,203.15Zm-9.61-14.63a6.42,6.42,0,0,0-.55,1.79,6.8,6.8,0,0,0,1-1.59,6.59,6.59,0,0,0,.55-1.78A6.74,6.74,0,0,0,452.12,188.52Zm-10-3.67a6.25,6.25,0,0,0-1.78-.55,7.19,7.19,0,0,0,3.36,1.54A6.54,6.54,0,0,0,442.14,184.85Zm9,14.79a6.42,6.42,0,0,0-1.79-.55,6.8,6.8,0,0,0,1.59,1,6.59,6.59,0,0,0,1.78.55A6.74,6.74,0,0,0,451.14,199.64Zm-7.32-25.33a6.25,6.25,0,0,0-1.78-.55,6.54,6.54,0,0,0,1.58,1,6.35,6.35,0,0,0,1.78.55A6.54,6.54,0,0,0,443.82,174.31Zm-5.58,19.75a6.71,6.71,0,0,0,.87,1.65,7.24,7.24,0,0,0-1.29-3.47A7,7,0,0,0,438.24,194.06Zm18.83,17.62a6.54,6.54,0,0,0,.87,1.65,7.24,7.24,0,0,0-1.29-3.47A6.52,6.52,0,0,0,457.07,211.68Zm-12.68-3,0,0,.33.39a6.29,6.29,0,0,0,1.53-.82A6.51,6.51,0,0,0,444.39,208.71Zm22.31,10.52a6.54,6.54,0,0,0,1.65-.87,6.52,6.52,0,0,0-1.82.42,6.23,6.23,0,0,0-1.65.87A6.9,6.9,0,0,0,466.7,219.23Zm-33.47-40.79a7.94,7.94,0,0,0-1.18.55l.09.25a6.61,6.61,0,0,0,1.25-.35,6.29,6.29,0,0,0,1.66-.87A6.81,6.81,0,0,0,433.23,178.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.46,226.77h-62s9.85-48.6,33.61-69.64c2.94-2.6,9.56-2,13.89.14,1.54.77,7.08,8.52,8.66,15.85S440.64,226.55,440.46,226.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.2,176.15c.49,1.64.89,3.33,1.22,5a1.34,1.34,0,0,1,0-.2c0-1,0-1.93.13-2.89,0,0,.09-.06.09,0a14.15,14.15,0,0,1,.08,2.91c0,.45-.05.91-.09,1.37.13.76.25,1.53.34,2.29.19,1.44.67,6.83.71,7.9,0,.22-.25.26-.31,0-.29-1.08-1.06-6.64-1.31-8.07a78.28,78.28,0,0,1-1-8.37C435.09,176.09,435.18,176.09,435.2,176.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,169.82a6.6,6.6,0,0,1-.56,1.78,6.25,6.25,0,0,1-1,1.58,6.72,6.72,0,0,1,.56-1.78A6.43,6.43,0,0,1,416,169.82Zm-8.4,24.68a6.25,6.25,0,0,0-.55,1.78,7.19,7.19,0,0,0,1.54-3.36A6.54,6.54,0,0,0,407.6,194.5Zm-20.13,8.83a6.42,6.42,0,0,0-.55,1.79,6.74,6.74,0,0,0,1-1.58,6.42,6.42,0,0,0,.55-1.79A6.74,6.74,0,0,0,387.47,203.33Zm14.8,15.83a6.25,6.25,0,0,0-.55,1.78,7.08,7.08,0,0,0,1-1.58,7.16,7.16,0,0,0,.55-1.79A6.48,6.48,0,0,0,402.27,219.16Zm25.83-30.58a6.77,6.77,0,0,0-.55,1.79,6.48,6.48,0,0,0,1-1.59,6.25,6.25,0,0,0,.55-1.78A7.08,7.08,0,0,0,428.1,188.58Zm8.14,16.79a6.42,6.42,0,0,0-.55,1.79,6.74,6.74,0,0,0,1-1.58,6.42,6.42,0,0,0,.55-1.79A7,7,0,0,0,436.24,205.37Zm-19.7,12.1a7.16,7.16,0,0,0-.55,1.79,6.48,6.48,0,0,0,1-1.59,6.6,6.6,0,0,0,.56-1.78A6.78,6.78,0,0,0,416.54,217.47Zm-18.87-32.73a6.72,6.72,0,0,0-.56,1.78,6.25,6.25,0,0,0,1-1.58,6.6,6.6,0,0,0,.56-1.78A6.43,6.43,0,0,0,397.67,184.74Zm23.42-5.52a6.25,6.25,0,0,0-1.78-.55,6.54,6.54,0,0,0,1.58,1,6.7,6.7,0,0,0,1.78.55A6.54,6.54,0,0,0,421.09,179.22ZM425,199.16a6.25,6.25,0,0,0-1.78-.55,6.86,6.86,0,0,0,1.58,1,6.59,6.59,0,0,0,1.78.55A6.25,6.25,0,0,0,425,199.16Zm-36.44,21.13a6.6,6.6,0,0,0-1.78-.56,6.25,6.25,0,0,0,1.58,1,6.83,6.83,0,0,0,1.78.56A6.25,6.25,0,0,0,388.56,220.29Zm37.08,4a6.7,6.7,0,0,0-1.78-.55,6.54,6.54,0,0,0,1.58,1l.38.17c.33,0,.65,0,1,.06A7.2,7.2,0,0,0,425.64,224.32Zm-23.15-20.18a6.59,6.59,0,0,0-1.78-.55,6.25,6.25,0,0,0,1.58,1,6.46,6.46,0,0,0,1.78.55A6.86,6.86,0,0,0,402.49,204.14Zm18.6-42.57a6.6,6.6,0,0,0-1.78-.56,6.58,6.58,0,0,0,1.58,1,7.09,7.09,0,0,0,1.78.55A6.25,6.25,0,0,0,421.09,161.57Zm4,9.25a6.39,6.39,0,0,0,.87,1.65,6.81,6.81,0,0,0-.42-1.82,6.69,6.69,0,0,0-.87-1.65A6.61,6.61,0,0,0,425.11,170.82ZM435,216.94a6.23,6.23,0,0,0,.87,1.65,7.24,7.24,0,0,0-1.29-3.47A6.52,6.52,0,0,0,435,216.94Zm-26.59-34.53a6.87,6.87,0,0,0,.87,1.65,6.51,6.51,0,0,0-.41-1.82,6.87,6.87,0,0,0-.87-1.65A6.88,6.88,0,0,0,408.36,182.41Zm7.66,20.3a6.37,6.37,0,0,0,.87,1.65,6.61,6.61,0,0,0-.42-1.82,6.71,6.71,0,0,0-.87-1.65A6.44,6.44,0,0,0,416,202.71Zm-35.51,23.81a2.11,2.11,0,0,0,0,.25h.16Zm17.44-.08a6.59,6.59,0,0,0-.87-1.66,6.44,6.44,0,0,0,.42,1.82l.06.17h.5C398,226.66,398,226.55,398,226.44Zm-3.56-14.31a6.71,6.71,0,0,0,.87,1.65,6.44,6.44,0,0,0-.42-1.82,6.37,6.37,0,0,0-.87-1.65A6.61,6.61,0,0,0,394.39,212.13Zm15-47.78a6.08,6.08,0,0,0,.87,1.65,6.61,6.61,0,0,0-.42-1.82,6.71,6.71,0,0,0-.87-1.65A6.44,6.44,0,0,0,409.4,164.35ZM426,211.18a6.69,6.69,0,0,0,1.65-.87,6.51,6.51,0,0,0-1.82.41,6.87,6.87,0,0,0-1.65.87A6.51,6.51,0,0,0,426,211.18ZM409.76,226.1a6.54,6.54,0,0,0,1.65-.87,7.24,7.24,0,0,0-3.47,1.29A6.52,6.52,0,0,0,409.76,226.1Zm-27.59-13.51c0,.14-.09.28-.13.42a5.38,5.38,0,0,0,.85-.52A5.43,5.43,0,0,0,382.17,212.59Zm14.14-17.19a6.59,6.59,0,0,0,1.66-.87,6.44,6.44,0,0,0-1.82.42,6.59,6.59,0,0,0-1.66.87A6.81,6.81,0,0,0,396.31,195.4Zm13,16.42A6.54,6.54,0,0,0,411,211a7.24,7.24,0,0,0-3.47,1.29A6.52,6.52,0,0,0,409.32,211.82ZM417,188.27a6.94,6.94,0,0,0,1.66-.87,6.43,6.43,0,0,0-1.82.41,6.69,6.69,0,0,0-1.65.87A6.44,6.44,0,0,0,417,188.27Zm16.35-9.38a6.29,6.29,0,0,0,1.66-.87,6.44,6.44,0,0,0-1.82.42,6.37,6.37,0,0,0-1.65.87A6.46,6.46,0,0,0,433.39,178.89Zm-29.23-5.48a6.54,6.54,0,0,0,1.65-.87,7.24,7.24,0,0,0-3.47,1.29A6.52,6.52,0,0,0,404.16,173.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.45,138c-.13-3,.47-16.67,1.49-20.44s4.74-14.42,7.71-13.93,2.13,3.69,2.13,3.69,2.28-4.25,5.23-3.49,1.47,5.71,1.47,5.71,2.66-4.19,5.55-3.22.57,5.69.57,5.69,2.25-3.94,4.29-2.14c2.45,2.16-2.53,9-3.34,13.21-.19,1-2.36,19.83-2.36,19.83Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.79,111.63c-3.66,5-4.39,7.84-4.79,13.93,0,.12-.19.13-.19,0-.15-6,.26-9.68,4.74-14.13C382.77,111.23,383,111.4,382.79,111.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.78,109.18c-3.34,5.53-4.16,8.59-5.06,14.93,0,.09-.16.08-.16,0,.36-6.3.85-10,4.91-15C376.66,108.82,376.93,108.92,376.78,109.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,107.67c-2.84,5.59-3.88,8.91-4,15.18a.12.12,0,0,1-.23,0c-.54-6.4.73-10.55,4-15.26C369.79,107.28,369.92,107.32,369.74,107.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,146.84s5.65-5.33,7.62-8.21,5.35-16.35,2.48-17.25c-3.7-1.15-7.18,6.23-8.41,10.07,0,0-8.56-2.68-12.2,2.08S381,146.84,381,146.84Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,121.4c-4.13,1.38-5.42,6.52-6.9,10.16a.36.36,0,0,1-.57.16c-3.66-.89-9.08-1.07-12,1.57a.09.09,0,0,1-.14-.12c2.81-3.27,8.15-3.52,12.1-2.3,1.45-3.75,3-8.86,7.55-9.51C390,121.35,390,121.39,390,121.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.53,164.38c-3.72,6.44-25.22,26.29-44,29.73-2.54.46-12.22-1.58-14.25-8-3.61-11.44-.72-35.06,1.12-49.28.36-2.77,26.14,2.93,25.47,7.17-.74,4.7-3.5,21.95-3.07,22.15,1.54.71,18-6.41,28.83-8.74C417.33,155.75,418.4,159.42,415.53,164.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79,143.85l29.38,6.36s-2.67,15-2.15,14.93,21.14-7.61,29.09-8.4,7.94,2.71,3.91,9.27-30.43,28.52-43.44,28.52c-6.62,0-12.78-4.24-14-6.27C353.87,182,354.79,143.85,354.79,143.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79,143.85l29.38,6.36s-2.67,15-2.15,14.93,21.14-7.61,29.09-8.4,7.94,2.71,3.91,9.27-30.43,28.52-43.44,28.52c-6.62,0-12.78-4.24-14-6.27C353.87,182,354.79,143.85,354.79,143.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.89,164.77a6.59,6.59,0,0,0-.55,1.78,6.25,6.25,0,0,0,1-1.58,6.35,6.35,0,0,0,.55-1.78A6.86,6.86,0,0,0,396.89,164.77ZM373.55,191a6.25,6.25,0,0,0-.55,1.78,7.19,7.19,0,0,0,1.54-3.36A6.74,6.74,0,0,0,373.55,191Zm-17.3-18a6.27,6.27,0,0,0-.56,1.78,6.58,6.58,0,0,0,1-1.58,7,7,0,0,0,.55-1.78A6.43,6.43,0,0,0,356.25,173Zm25.57.07a6.77,6.77,0,0,0-.55,1.79,6.3,6.3,0,0,0,1-1.59,6.6,6.6,0,0,0,.56-1.78A6.66,6.66,0,0,0,381.82,173.08ZM369,180.49a6.81,6.81,0,0,0-.55,1.78,6.25,6.25,0,0,0,1-1.58,6.6,6.6,0,0,0,.56-1.78A6.58,6.58,0,0,0,369,180.49Zm1.14-18.06a6.46,6.46,0,0,0-.55,1.78,7.19,7.19,0,0,0,1.54-3.36A6.54,6.54,0,0,0,370.09,162.43ZM357,149a6.6,6.6,0,0,0-.56,1.78,6,6,0,0,0,1-1.58,6.72,6.72,0,0,0,.56-1.78A6.54,6.54,0,0,0,357,149Zm52.83,15.17a6.54,6.54,0,0,0-.87-1.65,6.44,6.44,0,0,0,.42,1.82,6.34,6.34,0,0,0,.86,1.65A6.51,6.51,0,0,0,409.85,164.18Zm-17.4,12a6.69,6.69,0,0,0-.87-1.65,6.52,6.52,0,0,0,.42,1.82,6.23,6.23,0,0,0,.87,1.65A6.81,6.81,0,0,0,392.45,176.19Zm-13.07-13.53a6.54,6.54,0,0,0-.87-1.65,7.24,7.24,0,0,0,1.29,3.47A6.52,6.52,0,0,0,379.38,162.66Zm-1.69,19.58a6.54,6.54,0,0,0-.87-1.65,6.52,6.52,0,0,0,.42,1.82,6.37,6.37,0,0,0,.87,1.65A6.52,6.52,0,0,0,377.69,182.24Zm-16.76-2.11a6.37,6.37,0,0,0-.87-1.65,7,7,0,0,0,.42,1.82,6.54,6.54,0,0,0,.87,1.65A6.44,6.44,0,0,0,360.93,180.13Zm5.29-27.68a6.59,6.59,0,0,0-.87-1.66,6.58,6.58,0,0,0,.41,1.83,7.07,7.07,0,0,0,.87,1.65A6.43,6.43,0,0,0,366.22,152.45Zm-2,15.7a6.69,6.69,0,0,0-.87-1.65,6.52,6.52,0,0,0,.42,1.82,6.37,6.37,0,0,0,.87,1.65A6.44,6.44,0,0,0,364.24,168.15ZM404,173a6.54,6.54,0,0,0-1.65.87,6.61,6.61,0,0,0,1.82-.42,6.54,6.54,0,0,0,1.65-.87A6.52,6.52,0,0,0,404,173Zm-31.08-.72a7.07,7.07,0,0,0-1.65.87,6.44,6.44,0,0,0,1.82-.42,6.37,6.37,0,0,0,1.65-.87A6.52,6.52,0,0,0,372.91,172.24Zm2.94-18.46a6.69,6.69,0,0,0-1.65.87,6.46,6.46,0,0,0,1.81-.42,6.08,6.08,0,0,0,1.65-.87A6.46,6.46,0,0,0,375.85,153.78Zm-16.68,5.79a6.69,6.69,0,0,0-1.65.87,7.1,7.1,0,0,0,3.47-1.28A6.8,6.8,0,0,0,359.17,159.57Zm27.73,25a6.87,6.87,0,0,0-1.65.87,7.1,7.1,0,0,0,3.47-1.28A6.51,6.51,0,0,0,386.9,184.61Zm-22.33,4.89a6.54,6.54,0,0,0-1.65.87,6.44,6.44,0,0,0,1.82-.42,6.37,6.37,0,0,0,1.65-.87A6.52,6.52,0,0,0,364.57,189.5Zm24.07-24.86a6.69,6.69,0,0,0-1.65.87,7,7,0,0,0,1.82-.41,7.07,7.07,0,0,0,1.65-.87A6.43,6.43,0,0,0,388.64,164.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.25,165.27a45,45,0,0,1-1.17,6.64c-.49,2.22-1.19,4.37-1.84,6.54a0,0,0,0,1-.08,0c.57-2.18,1-4.41,1.46-6.62s.81-4.42,1.38-6.6C382,165.07,382.26,165.12,382.25,165.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,155.75c-3.4-.84-6.84-1.51-10.29-2.16s-6.9-1.32-10.36-1.89c-2-.32-3.92-.65-5.89-.91,0,0-.07.08,0,.09,3.39.85,6.84,1.53,10.28,2.21s6.9,1.32,10.35,1.93c2,.34,3.92.65,5.89.9C382.49,155.94,382.54,155.78,382.44,155.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.14,185.76c.54-.48,1.14-.89,1.71-1.33s1.1-.87,1.66-1.29l3.4-2.61c2.26-1.75,4.48-3.56,6.72-5.34,1.28-1,2.54-2,3.8-3.08a.05.05,0,0,1,.07.08c-1.54,1.45-3.1,2.88-4.7,4.26l.6-.29c.62-.31,1.22-.64,1.82-1,0,0,.09.05,0,.08a16,16,0,0,1-1.76,1.08c-.3.16-.6.32-.91.46l-.45.19h0c-.36.31-.72.62-1.09.92q-3.33,2.72-6.8,5.23-1,.69-1.95,1.35c-.69.45-1.36.95-2.09,1.36A.06.06,0,0,1,392.14,185.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "421.3 171.97 424.73 166.75 427.96 171.14 426.64 175.02 422.98 175.1 421.3 171.97",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.98 175.1 416.9 215.53 423.07 229.78 428.64 215.09 426.64 175.02 422.98 175.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,166.38c-3.57.86-9.74-4.56-12.19-9-.17-.3.28-3.5.63-7.42.21-2.38.38-5,.37-7.47l15.28,3.61a38.51,38.51,0,0,0-1.41,9.35,4.51,4.51,0,0,0,.11,1c0,.05,0,.1,0,.17C429.09,158.53,429.41,165.53,426,166.38Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.84,142.77c.47,3.22,2.65,13.82,11.36,14a9.63,9.63,0,0,0,1.57-.09,1.28,1.28,0,0,1,0-.17,5.17,5.17,0,0,1-.12-1,38.94,38.94,0,0,1,1.42-9.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.25,125.46c-1.17,5.53,3.06,20.85,7.2,24,6,4.54,15.14,4.21,18.82-2.85,3.57-6.84-2.29-26.7-6.85-29.47C423.7,113,413,117.28,411.25,125.46Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.89,134.54s-.07.07-.06.11c.31,1,.5,2.25-.34,2.85,0,0,0,.07,0,.05C425.61,137.08,425.35,135.46,424.89,134.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.67,133.71c-1.69.32-.92,3.69.65,3.39S425.09,133.44,423.67,133.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.11,133c0-.05.09,0,.1.07.2,1.05.62,2.22,1.64,2.35,0,0,0,.06,0,.06C431.67,135.57,431.13,134,431.11,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.79,131.68c1.65-.51,2.55,2.83,1,3.3S430.41,132.11,431.79,131.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,132.48c.43-.22.79-.5,1.2-.76s.85-.49,1.07-1a.72.72,0,0,0-.31-.83,1.79,1.79,0,0,0-1.82.22,2.68,2.68,0,0,0-1.24,1.47A.78.78,0,0,0,422,132.48Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.7,129.69a13.54,13.54,0,0,1-1.42,0,2.22,2.22,0,0,1-1.43-.32.73.73,0,0,1-.16-.88,1.81,1.81,0,0,1,1.68-.73,2.65,2.65,0,0,1,1.81.63A.78.78,0,0,1,432.7,129.69Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.47,144.16c.31.19.63.47,1,.41a2.7,2.7,0,0,0,1.06-.52,0,0,0,0,1,.06,0,1.45,1.45,0,0,1-1.2.87,1.15,1.15,0,0,1-1-.74C426.35,144.17,426.43,144.13,426.47,144.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.85,140.79a3.63,3.63,0,0,0,2.74,1,4.44,4.44,0,0,0,1.29-.23l.23-.08.23-.09a.27.27,0,0,0,.15-.28h0a.49.49,0,0,0,0-.11h0l0-.09c-.16-.81-.52-2-.52-2,.33.08,2,.41,1.86,0a55.1,55.1,0,0,0-3.84-10.43.1.1,0,0,0-.19.07c.84,3.33,2.25,6.49,3.14,9.82a6.22,6.22,0,0,0-1.79-.12c-.11.06.73,2.31.78,2.68v0a5,5,0,0,1-3.94-.3C426.84,140.63,426.77,140.72,426.85,140.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,141.42a4.38,4.38,0,0,1-1.47,1.64,2,2,0,0,1-1.14.28c-.89-.07-1-.84-1-1.52a4.33,4.33,0,0,1,.19-1.08A5.62,5.62,0,0,0,430.32,141.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.85,143.06a2,2,0,0,1-1.14.28c-.89-.07-1-.84-1-1.52A2,2,0,0,1,428.85,143.06Z",
    style: {
      fill: "#ff9cbd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.5,127.36a13.14,13.14,0,0,0,1.65-.25c.55-.14,1.06-.39,1.61-.52a9.23,9.23,0,0,1,3.19,0c.09,0,.09.07,0,.06a7.81,7.81,0,0,0-3.33.27,9.91,9.91,0,0,1-2.68.65,10,10,0,0,0-5.86,1.94s0,0,0,0A9.94,9.94,0,0,1,426.5,127.36Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M426.14,125.9a10.43,10.43,0,0,0,1.57-.23c.52-.13,1-.37,1.53-.49a8.74,8.74,0,0,1,3,0c.09,0,.09.07,0,.06a7.65,7.65,0,0,0-3.16.26,9.24,9.24,0,0,1-2.54.61,9.48,9.48,0,0,0-5.55,1.85s0,0,0,0A9.51,9.51,0,0,1,426.14,125.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,138.66s-5.36-8.83-4.86-13.94c.22-2.31,3.36-3.86,3.36-3.86a5.22,5.22,0,0,1,1.65-5.25c2.73-2.57,9.34-2,9.34-2s4.28-6.19,10.34-3.74,2.12,9.32,2.12,9.32,2.22,3.16-3.21,5.63-16.1.05-16.1.05a37.55,37.55,0,0,1-.16,11.2A3.44,3.44,0,0,1,412.77,138.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.3,113.69a10.52,10.52,0,0,0-4.26-.77,11.39,11.39,0,0,0-3.84.6,6.37,6.37,0,0,0-4.49,4.79,4.46,4.46,0,0,0,.85,3.35s.09,0,.06,0c-1.4-1.74-.67-4.44.78-5.89a9.66,9.66,0,0,1,6.39-2.37,19.18,19.18,0,0,1,4.47.47C423.35,113.84,423.38,113.73,423.3,113.69Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,112.79a5.19,5.19,0,0,0-3.6-3.3,8.83,8.83,0,0,0-5.74.2,11.29,11.29,0,0,0-4.69,3.48s0,.08.06,0a9.8,9.8,0,0,1,9.37-3.49,4.8,4.8,0,0,1,3.75,7.15,10,10,0,0,1-3.89,3.91,0,0,0,1,0,0,.06,10.38,10.38,0,0,0,3.88-3.32A5.85,5.85,0,0,0,436.94,112.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.7,137.85s-4.06-4.64-6.21-3.14,1.3,8.5,4.08,9.2a2.73,2.73,0,0,0,3.49-1.86Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.53,136.69a0,0,0,0,0,0,.07c2,.56,3.14,2.19,4,3.92a1.53,1.53,0,0,0-2.3-.17.06.06,0,0,0,.07.1,1.67,1.67,0,0,1,1.9.38,8,8,0,0,1,1,1.4c.1.16.4,0,.31-.15l0,0C415.35,139.8,413.12,136.65,410.53,136.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59,140a4.72,4.72,0,1,1,3.75-6.44h0a4.72,4.72,0,0,1-2.62,6.14A5.1,5.1,0,0,1,424.59,140Zm-1.16-8.74a4.53,4.53,0,0,0-1,.26,4.08,4.08,0,1,0,1-.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.07,137.26c-1.79.24-3.66-1.38-4.27-3.76a5.67,5.67,0,0,1,.16-3.45,2.93,2.93,0,0,1,4.87-1.23,5.48,5.48,0,0,1,1.78,3c.64,2.52-.36,5-2.24,5.43A1.59,1.59,0,0,1,435.07,137.26Zm-1.63-8.63-.24,0a2.54,2.54,0,0,0-1.66,1.62,5.06,5.06,0,0,0-.13,3.05c.56,2.19,2.26,3.65,3.8,3.25s2.35-2.48,1.79-4.67a5,5,0,0,0-1.57-2.62A2.56,2.56,0,0,0,433.44,128.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.33,134.12l-.52-.37c.55-.76,1.95-1.95,3.37-1l-.34.53C429.57,132.43,428.38,134.05,428.33,134.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.25,140.47l-.61-.14c.06-.29.68-2.81,2-3.38s9.62-1.85,10-1.9l.1.62c-2.41.38-8.87,1.44-9.82,1.86S408.41,139.78,408.25,140.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.76,156.31l-4.27,8.76L414.12,153l-3.41,3.43s9.67,18.78,9.79,18l4.23-7.48,5,5.75.49-13.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.32,165.94c0-2.24.08-4.49,0-6.73,0-.07-.13-.12-.15,0-.59,2.12-.58,10.68-.73,12.72l0,0c-.2-.24-4.62-5.07-4.67-5-.89,1.17-4,6.62-4.21,7.12-1.52-3-7.42-13.85-9.27-16.7a.08.08,0,0,0-.14.07c1.31,3.13,9.1,17.75,9.23,17.72a87.11,87.11,0,0,0,4.43-7.91c.73,1,5.15,6.44,5.19,6.11A72,72,0,0,0,430.32,165.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.43,223c-3.67,5.24-13.66,6.25-38.56,11.12-3.45.68-14.76-22.36-11.12-23.27,4.59-1.15,22.65-4.6,24-4.69C455.16,205.4,471.92,219.4,469.43,223Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.74,209.67s-10.56,1.6-15.84,4.15a37.74,37.74,0,0,0-13.6,11.86c-3.8,5.38-9.28,21-5.05,23.38,3.83,2.14,8.62-14.12,8.62-14.12s-7.62,15.77-2.54,17.5S405.9,235,405.9,235s-7.47,16.39-1.95,17.34c4.18.72,9.22-16.44,9.22-16.44s-6.32,14.13-2.06,15.06c4.71,1,10.36-14.53,10.36-14.53,11.22.53,16.78-3.81,20.37-7.37C442.71,228.17,424.74,209.67,424.74,209.67Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.15,229.31c-1,1.82-1.95,3.66-2.74,5.56s-1.53,3.83-2.15,5.79a35.68,35.68,0,0,0-1.67,7.88c.8-4.72,3.55-11.57,4.35-13.47s1.49-3.84,2.29-5.73C401.25,229.29,401.18,229.27,401.15,229.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,232.06c-1.13,2.38-2.34,4.7-3.36,7.13s-1.77,4.8-2.62,7.28c-.07.19.06.16.13,0,.95-2.44,2-4.63,3-7.06s1.86-4.91,2.92-7.3C408.14,232.05,408.08,232,408.07,232.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.43,233.36a58.13,58.13,0,0,0-4.3,11.29c-.06.19.1.14.16-.06,1.36-3.78,2.4-6.75,4.26-11.17C414.58,233.36,414.47,233.28,414.43,233.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.54,209.67,444.36,234s22.07-5.06,25.32-10.72c2.14-3.73-14.48-18.82-27-17.06Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.91,224.84a6.46,6.46,0,0,1-.55,1.78,6.25,6.25,0,0,1-1,1.58,6.59,6.59,0,0,1,.55-1.78A6.86,6.86,0,0,1,441.91,224.84Zm15.16-1.37a6.77,6.77,0,0,0-.55,1.79,6.48,6.48,0,0,0,1-1.59,6.6,6.6,0,0,0,.56-1.78A6.78,6.78,0,0,0,457.07,223.47Zm-10.81-5.1a6.25,6.25,0,0,0-1.78-.55,7.19,7.19,0,0,0,3.36,1.54A6.54,6.54,0,0,0,446.26,218.37Zm10.81-6.69a6.54,6.54,0,0,0,.87,1.65,7.24,7.24,0,0,0-1.29-3.47A6.52,6.52,0,0,0,457.07,211.68ZM435,216.94a6.23,6.23,0,0,0,.87,1.65,7.24,7.24,0,0,0-1.29-3.47A6.52,6.52,0,0,0,435,216.94Zm-9-5.76a6.69,6.69,0,0,0,1.65-.87,6.51,6.51,0,0,0-1.82.41,6.87,6.87,0,0,0-1.65.87A6.51,6.51,0,0,0,426,211.18Zm18.58-2a6.69,6.69,0,0,0,1.65-.87,6.59,6.59,0,0,0-1.82.41,7.07,7.07,0,0,0-1.65.87A6.8,6.8,0,0,0,444.56,209.17Zm6.88,21.36a6.54,6.54,0,0,0,1.65-.87,6.44,6.44,0,0,0-1.82.42,6.37,6.37,0,0,0-1.65.87A6.61,6.61,0,0,0,451.44,230.53Zm16.4-12.12a7.51,7.51,0,0,0-1.31.37,6.54,6.54,0,0,0-1.65.87,6.9,6.9,0,0,0,1.82-.42,6.42,6.42,0,0,0,1.29-.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.62,210.14a21.74,21.74,0,0,0-15-4c-.06,0-.06.11,0,.11,5.48-.15,12.87,2.71,14.94,3.95C457.63,210.27,457.68,210.18,457.62,210.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.33,229.9c-2.26-2.8-4.66-5.47-7.08-8.14s-4.82-5.35-7.3-8c-1.4-1.47-2.79-3-4.24-4.38a.05.05,0,0,0-.08.06c2.26,2.79,4.65,5.48,7,8.16s4.82,5.36,7.27,8c1.38,1.49,2.79,3,4.24,4.39C450.26,230.09,450.39,230,450.33,229.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,209.36a29.93,29.93,0,0,1,4.09-.94c1.37-.25,2.76-.49,4.14-.71,2.75-.44,8.53-1.69,13.61-1.68.06,0-.23.28-.29.27-2.42-.13-19.75,3.32-21.17,3.42.05.1.11.19.15.29a.08.08,0,0,1-.12.11c-.18-.12-.3-.27-.47-.4A.2.2,0,0,1,422.5,209.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cursor--inject-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "301.87 268.19 306.06 278.33 301.87 280.07 297.65 269.86 290.72 275.24 290.72 246.68 310.71 266.88 301.87 268.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,242.89a3.5,3.5,0,0,1-.5-1.9,3.45,3.45,0,0,1,.5-1.89,3.62,3.62,0,0,1,.5,1.89A3.68,3.68,0,0,1,291,242.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.71,244.24a3.56,3.56,0,0,1-1.7-1,3.51,3.51,0,0,1-1-1.69,3.51,3.51,0,0,1,1.69,1A3.64,3.64,0,0,1,287.71,244.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.36,247.5a3.68,3.68,0,0,1-1.9.5,3.62,3.62,0,0,1-1.89-.5,3.45,3.45,0,0,1,1.89-.5A3.59,3.59,0,0,1,286.36,247.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.71,250.76a3.66,3.66,0,0,1-1,1.69,3.53,3.53,0,0,1-1.69,1,3.47,3.47,0,0,1,1-1.69A3.56,3.56,0,0,1,287.71,250.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.58,247.5a3.53,3.53,0,0,1,1.89-.5,3.48,3.48,0,0,1,1.9.5,3.84,3.84,0,0,1-3.79,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.23,244.24a3.63,3.63,0,0,1,1-1.7,3.54,3.54,0,0,1,1.7-1,3.53,3.53,0,0,1-1,1.69A3.57,3.57,0,0,1,294.23,244.24Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.78,340.47a67.14,67.14,0,0,0-2.17,12.31c.11.21.09,1,0,.76,0,.67-1,.55-1-.11,0-.44,0-.87,0-1.3-2.4-3-5.89-4.87-8.72-7.47a16.28,16.28,0,0,1-4.77-7.6c-2.34-8.07-.15-16.61-3-24.66-2.42-6.94-6.77-13-10.46-19.25-3.89-6.65-6.75-13.63-7-21.42-.23-6,.48-13.9,5-18.37,4.81-4.74,10.78-1.19,14.47,3,10.68,12.26,15.62,27.76,17.62,43.6,1.1,8.77,2.25,17.59,2,26.44A71.24,71.24,0,0,1,104.78,340.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.65,356a150.36,150.36,0,0,0-.29-24.84s0-.05,0-.09c.13-6.72.67-13.41.4-20.13a119.06,119.06,0,0,0-3-21.59c0-.08-.15-.06-.13,0a141.14,141.14,0,0,1,2.33,21.11c.14,3.8.11,7.59-.09,11.39-.06,1.23-.18,2.47-.26,3.71h0a132.91,132.91,0,0,0-20-52.87c-.14-.22-.53,0-.39.24a138.32,138.32,0,0,1,16.26,39.2c-5.14-9.52-12.9-17.34-18.65-26.49,0,0-.12,0-.09.05C84,295.89,92.57,303.92,98,314q1.42,6.14,2.3,12.37a139.22,139.22,0,0,1,1.24,17.18c-3.13-5.85-6.38-11.44-8.94-17.63-.07-.17-.31-.05-.25.11,2.18,6.43,5.11,13.35,9.2,18.83,0,4.07-.09,8.14-.33,12.2-.64,10.85-2.5,21.55-3.35,32.36a.25.25,0,0,0,.49.05A247.11,247.11,0,0,0,102.65,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.13,272.35c0-.07-.14,0-.12.06,2,5.48,3.1,11,4.54,16.64A.2.2,0,0,0,96,289C95.37,283.29,93.34,277.61,91.13,272.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.44,295.31a80.89,80.89,0,0,1-4.56,9.36c-3.56,6.48-7.28,12.42-8,20-.3,3.37-.41,6.75-1.43,10a29.93,29.93,0,0,1-4,7.82c-3.86,5.64-8.7,10.49-12.28,16.33a68.71,68.71,0,0,0-8.16,19.68c-.09.38-.68.28-.6-.1a.24.24,0,0,0,0-.09.09.09,0,0,1,0-.08c-.57-16.17.72-32.47,5.66-48a166.45,166.45,0,0,1,7.84-20c2.64-5.62,5.93-11,10.57-15.22,3-2.71,9.54-7.85,13.83-5.13C142.4,291.23,142.25,293.3,141.44,295.31Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.19,332a134.05,134.05,0,0,1-9.4,13.51c-1.57,2.05-3.16,4.07-4.72,6.12-.74,1-1.57,1.93-2.25,3,.43-1.7.85-3.4,1.28-5.1,2.09-8.17,4.09-16.42,7.2-24.28a163.93,163.93,0,0,1,11.23-22c.11-.19-.19-.32-.3-.14-3.42,5.62-6.89,11.23-9.76,17.16a87.87,87.87,0,0,0-4.14,10.18,158,158,0,0,1,5.51-21.76c0-.06-.07-.11-.1,0A74.45,74.45,0,0,0,114,331.22v0c-.7,2.1-1.34,4.22-1.94,6.36-2.55,9.05-4.79,18.19-6.86,27.37a97,97,0,0,1,1.56-18,.11.11,0,0,0-.21,0,56.84,56.84,0,0,0-1.57,19q-1.17,5.24-2.29,10.47c-1.59,7.46-3.54,15.05-4.47,22.62a.15.15,0,0,0,.3.05c1.11-4.08,1.78-8.31,2.68-12.44s1.85-8.29,2.82-12.42c1.4-6,2.87-12,4.37-18,1-2.2,2.94-4.15,4.39-6,1.59-2,3.19-4,4.74-6.1a91.93,91.93,0,0,0,7.78-12C125.38,332,125.24,331.89,125.19,332Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,325.06a84.15,84.15,0,0,0-9.2,14.62c0,.06.07.13.11.07,3.09-4.85,6.14-9.74,9.23-14.6C126.07,325.07,125.93,325,125.88,325.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,310.65c2.1,3.61,4.49,7.94,3.59,12.28-.57,2.74-2.58,5-2.94,7.77-.81,6.18,5.35,10.26,9.8,13.18,11.11,7.29,26.34,13.78,28.36,28.66.07.53,1,.4.92-.12a.44.44,0,0,0,0-.1s0,0,0-.08a56.85,56.85,0,0,0-.21-22.73c-1.65-7.67-5-14.56-8.95-21.3-6.68-11.4-13.76-23.08-23.87-31.82C61,294,55.22,289.63,53,295.09,50.83,300.39,54.46,306.25,57,310.65Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,334.82c7.36,8,19.07,12.44,25.41,21.37a89.56,89.56,0,0,0-19.53-36.68.29.29,0,0,1,.41-.4,72.3,72.3,0,0,1,16,23.11,103.81,103.81,0,0,0-6.87-17.58.19.19,0,0,1,.33-.19,67,67,0,0,1,7.4,19.76c8.35,20.22,9.13,43.93,7.38,65.24,0,.3-.49.31-.48,0,.48-16.79.21-33.88-3.82-50.28-.08-.35-.18-.68-.26-1-6.9-9.62-18.55-14.07-26-23.2C67,334.86,67.11,334.74,67.19,334.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.48,328c3.87,3.54,7.67,7.17,11.54,10.72,0,0,0,.1,0,.07a56.36,56.36,0,0,1-11.72-10.56C65.12,328.05,65.32,327.83,65.48,328Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,312.61a120.29,120.29,0,0,0,11.57,15.91c0,.07,0,.16-.1.1a55.84,55.84,0,0,1-11.68-15.89C64.6,312.6,64.79,312.48,64.87,312.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.27 424.48 116.13 424.48 111.57 378.93 87.49 378.93 82.27 424.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.64 386.33 112.31 386.33 111.57 378.93 87.49 378.93 86.64 386.33",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.33,
    y: 373.88,
    width: 31.74,
    height: 7.27,
    transform: "translate(198.41 755.03) rotate(180)",
    style: {
      fill: "#455a64"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutus);
export default __webpack_public_path__ + "static/media/aboutus.f6ff6043389fd71c49cfe1ef8fb54f98.svg";
export { ForwardRef as ReactComponent };